
import * as THREE from "../../libs/three.js/build/three.module.js";
import { ClipTask, ClipMethod, CameraMode, LengthUnits, ElevationGradientRepeat, ShowMode } from "../defines.js";
import { Renderer } from "../PotreeRenderer.js";
import { PotreeRenderer } from "./PotreeRenderer.js";
import { EDLRenderer } from "./EDLRenderer.js";
import { HQSplatRenderer } from "./HQSplatRenderer.js";
import { Scene } from "./Scene.js";
import { CSS3DLayer } from "./CSS3DLayer.js";
import { HolePunchLayer } from "./HolePunchLayer.js";
import { ClippingTool } from "../utils/ClippingTool.js";
import { TransformationTool } from "../utils/TransformationTool.js";
import { Utils } from "../utils.js";
import { MapView } from "./map.js";
import { ProfileWindow, ProfileWindowController } from "./profile.js";
import { YDBoxVolume, BoxVolume } from "../utils/Volume.js";
import { YDPolygonVolume } from "../utils/YDPolygonVolume.js";
import { DeviceRegionManager } from "../utils/DeviceRegionManager.js";
import { Features } from "../Features.js";
import { getSparkRenderer } from "../modules/spark/index.js";
import { Message } from "../utils/Message.js";
import { Sidebar } from "./sidebar.js";

import { AnnotationTool } from "../utils/AnnotationTool.js";
import { MeasuringTool } from "../utils/MeasuringTool.js";
import { ProfileTool } from "../utils/ProfileTool.js";
import { VolumeTool } from "../utils/VolumeTool.js";
import { PolygonVolumeTool } from "../utils/PolygonVolumeTool.js";

import { InputHandler } from "../navigation/InputHandler.js";
import { NavigationCube } from "./NavigationCube.js";
import { Compass } from "../utils/Compass.js";
import { OrbitControls } from "../navigation/OrbitControls.js";
import { FirstPersonControls } from "../navigation/FirstPersonControls.js";
import { EarthControls } from "../navigation/EarthControls.js";
import { DeviceOrientationControls } from "../navigation/DeviceOrientationControls.js";
import { VRControls } from "../navigation/VRControls.js";
import { EventDispatcher } from "../EventDispatcher.js";
import { ClassificationScheme } from "../materials/ClassificationScheme.js";
import { VRButton } from '../../libs/three.js/examples/jsm/webxr/VRButton.js';

import JSON5 from "../../libs/json5-2.1.3/json5.mjs";

export class Viewer extends EventDispatcher {

	constructor(domElement, args = {}) {
		super();

		this.renderArea = domElement;
		this.guiLoaded = false;
		this.guiLoadTasks = [];

		this.onVrListeners = [];

		this.messages = [];
		this.elMessages = $(`
		<div id="message_listing" 
			style="position: absolute; z-index: 1000; left: 10px; bottom: 10px">
		</div>`);
		$(domElement).append(this.elMessages);

		try {

			{ // generate missing dom hierarchy
				if ($(domElement).find('#potree_map').length === 0) {
					let potreeMap = $(`
					<div id="potree_map" class="mapBox" style="position: absolute; left: 50px; top: 50px; width: 400px; height: 400px; display: none">
						<div id="potree_map_header" style="position: absolute; width: 100%; height: 25px; top: 0px; background-color: rgba(0,0,0,0.5); z-index: 1000; border-top-left-radius: 3px; border-top-right-radius: 3px;">
						</div>
						<div id="potree_map_content" class="map" style="position: absolute; z-index: 100; top: 25px; width: 100%; height: calc(100% - 25px); border: 2px solid rgba(0,0,0,0.5); box-sizing: border-box;"></div>
					</div>
				`);
					$(domElement).append(potreeMap);
				}

				if ($(domElement).find('#potree_description').length === 0) {
					let potreeDescription = $(`<div id="potree_description" class="potree_info_text"></div>`);
					$(domElement).append(potreeDescription);
				}

				if ($(domElement).find('#potree_annotations').length === 0) {
					let potreeAnnotationContainer = $(`
					<div id="potree_annotation_container" 
						style="position: absolute; z-index: 100000; width: 100%; height: 100%; pointer-events: none;"></div>`);
					$(domElement).append(potreeAnnotationContainer);
				}

				if ($(domElement).find('#potree_quick_buttons').length === 0) {
					let potreeMap = $(`
					<div id="potree_quick_buttons" class="quick_buttons_container" style="">
					</div>
				`);

					// {
					// 	let imgMenuToggle = document.createElement('img');
					// 	imgMenuToggle.src = new URL(Potree.resourcePath + '/icons/menu_button.svg').href;
					// 	imgMenuToggle.onclick = this.toggleSidebar;
					// 	// imgMenuToggle.classList.add('potree_menu_toggle');

					// 	potreeMap.append(imgMenuToggle);
					// }

					// {
					// 	let imgMenuToggle = document.createElement('img');
					// 	imgMenuToggle.src = new URL(Potree.resourcePath + '/icons/menu_button.svg').href;
					// 	imgMenuToggle.onclick = this.toggleSidebar;
					// 	// imgMenuToggle.classList.add('potree_menu_toggle');

					// 	potreeMap.append(imgMenuToggle);
					// }

					// {
					// 	let imgMenuToggle = document.createElement('img');
					// 	imgMenuToggle.src = new URL(Potree.resourcePath + '/icons/menu_button.svg').href;
					// 	imgMenuToggle.onclick = this.toggleSidebar;
					// 	// imgMenuToggle.classList.add('potree_menu_toggle');

					// 	potreeMap.append(imgMenuToggle);
					// }



					$(domElement).append(potreeMap);
				}
			}

			this.pointCloudLoadedCallback = args.onPointCloudLoaded || function () { };

			// if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
			//	defaultSettings.navigation = "Orbit";
			// }

			this.server = null;

			this.fov = 60;
			this.isFlipYZ = false;
			this.useDEMCollisions = false;
			this.generateDEM = false;
			this.minNodeSize = 30;
			this.edlStrength = 1.0;
			this.edlRadius = 1.4;
			this.edlOpacity = 1.0;
			this.useEDL = false;
			this.description = "";
			this.sceneShowModel = ShowMode.PointClouds

			this.classifications = ClassificationScheme.DEFAULT;

			this.moveSpeed = 10;

			this.lengthUnit = LengthUnits.METER;
			this.lengthUnitDisplay = LengthUnits.METER;

			this.showBoundingBox = false;
			this.showAnnotations = true;
			this.freeze = false;

			// 视距剔除：超出阈值距离的 volume/measurement/profile/annotation 自动隐藏以减少开销。
			// 默认关闭，保持既有行为不变；开启后由 updateViewDistanceCulling / updateAnnotations 每帧生效。
			this.viewDistanceCullingEnabled = false;
			this.viewDistanceCullingRange = 1000;

			// 标注聚合（工业级组合方案）：3D体素分箱 + 分层动态阈值 + 屏幕像素二次过滤 + 缓存防抖 + 点击解聚。
			// 默认关闭；与视距剔除可同时开启（视距剔除先过滤极远的，聚合再对剩余的中远标注分组）。
			this.annotationClusteringEnabled = false;
			this.annotationClusteringPixelThreshold = 40;   // 第2阶段：远景聚合点屏幕像素合并阈值
			this.annotationClusteringMinDistance = 100;      // near：相机距离 <= 此值不聚合，显示原始图标
			this.annotationClusteringFarDistance = 300;      // far：聚合点平均距离 >= 此值才叠加屏幕像素合并
			this.annotationClusteringVoxelSize = 0;          // 0=自动从标注包围盒推导；>0=手动覆盖（世界单位）
			this.annotationClusteringVoxelFactor = 1.0;      // 自动体素尺寸的倍率微调
			// 每类型聚合覆盖配置：{ [type]: { near, far, marker:{background,color,size,borderRadius,fontSize,backgroundImage} } }
			// 未配置的类型回退到全局 near/far 与默认标记样式。按类型分组，不同类型不会聚到一起。
			this.annotationClusteringTypeStyles = {};

			this.clipTask = ClipTask.HIGHLIGHT;
			this.clipMethod = ClipMethod.INSIDE_ANY;

			this.elevationGradientRepeat = ElevationGradientRepeat.CLAMP;

			this.filterReturnNumberRange = [0, 7];
			this.filterNumberOfReturnsRange = [0, 7];
			this.filterGPSTimeRange = [-Infinity, Infinity];
			this.filterPointSourceIDRange = [0, 65535];

			this.potreeRenderer = null;
			this.edlRenderer = null;
			this.renderer = null;
			this.pRenderer = null;

			this.scene = null;
			this.sceneVR = null;
			this.overlay = null;
			this.overlayCamera = null;

			this.inputHandler = null;
			this.controls = null;

			this.clippingTool = null;
			this.transformationTool = null;
			this.navigationCube = null;
			this.compass = null;

			this.skybox = null;
			this.clock = new THREE.Clock();
			this.background = null;

			// 设备区域着色管理器(点云+高斯，选中/闪烁)。默认无高亮 → 零开销。
			this.deviceRegionManager = new DeviceRegionManager(this);

			this.initThree();
			this.cameraPBK = new THREE.PerspectiveCamera(this.fov, 1, 0.1, 1000 * 1000);
			this.viewPositionBK = new THREE.Vector3(0, 0, 0);
			if (args.noDragAndDrop) {

			} else {
				this.initDragAndDrop();
			}

			if (typeof Stats !== "undefined") {
				this.stats = new Stats();
				this.stats.showPanel(0); // 0: fps, 1: ms, 2: mb, 3+: custom
				document.body.appendChild(this.stats.dom);
			}

			{
				let canvas = this.renderer.domElement;
				canvas.addEventListener("webglcontextlost", (e) => {
					console.log(e);
					this.postMessage("WebGL context lost. \u2639");

					let gl = this.renderer.getContext();
					let error = gl.getError();
					console.log(error);
				}, false);
			}

			{
				this.overlay = new THREE.Scene();
				this.overlayCamera = new THREE.OrthographicCamera(
					0, 1,
					1, 0,
					-1000, 1000
				);
			}

			this.pRenderer = new Renderer(this.renderer);

			{
				let near = 2.5;
				let far = 10.0;
				let fov = 90;

				this.shadowTestCam = new THREE.PerspectiveCamera(90, 1, near, far);
				this.shadowTestCam.position.set(3.50, -2.80, 8.561);
				this.shadowTestCam.lookAt(new THREE.Vector3(0, 0, 4.87));
			}


			let scene = new Scene(this.renderer);

			{ // create VR scene
				this.sceneVR = new THREE.Scene();
			}

			this.setScene(scene);

			{
				this.inputHandler = new InputHandler(this);
				this.inputHandler.setScene(this.scene);

				this.clippingTool = new ClippingTool(this);
				this.transformationTool = new TransformationTool(this);
				this.navigationCube = new NavigationCube(this);
				this.navigationCube.visible = false;

				this.compass = new Compass(this);

				this.createControls();

				this.clippingTool.setScene(this.scene);

				let onPointcloudAdded = (e) => {
					if (this.scene.pointclouds.length === 1 && e.resetSpeed == true) {
						let speed = e.pointcloud.boundingBox.getSize(new THREE.Vector3()).length();
						speed = speed / 5;
						this.setMoveSpeed(speed);
					}
				};

				let onGaussianSplatsAdded = (e) => {
					// 业务可直连顶层 spark 模块副本自建 SplatMesh 后经
					// scene.addGaussianSplats 挂载（不经 loadGaussianSplat，原链路无
					// 机会建渲染器，跨实例 mesh 无收集者即永不显示）。这里幂等补建，
					// 使 SparkRenderer 存在于 mesh 加入之后（getSparkRenderer 内部缓存）。
					getSparkRenderer(this).catch((err) => {
						console.error("[3DGS] ensure SparkRenderer after addGaussianSplats failed:", err);
					});
					// viewer.update 仅在点云可见时重算 near/far（lowestSpacing !==
					// Infinity 分支）。先点云后切纯 gs 站的场景里，点云清空后 near/far
					// 冻结在点云末帧值——顶视图粗 LOD 可把 near 冻在米级~数十米，
					// spark splat shader 消费相机 near/far 做深度编码/尺度，近距会
					// 糊成光团。挂载即重置为构造默认值；有点云时不干预（ALL 模式
					// near/far 仍由点云逐帧维护），全景期的自定义裁剪也不受影响
					//（全景期不挂载 gs，本钩子不触发）。
					if (this.scene.pointclouds.length === 0) {
						this.scene.cameraP.near = 0.1;
						this.scene.cameraP.far = 1000 * 1000;
						this.scene.cameraP.updateProjectionMatrix();
					}
					// if (this.scene.pointclouds.length === 0 && this.scene.gaussianSplats.length === 1) {
					// 	let speed = e.gaussianSplat.boundingBox.getSize(new THREE.Vector3()).length();
					// 	speed = speed / 5;
					// 	this.setMoveSpeed(speed);
					// }
				}

				let onVolumeRemoved = (e) => {
					this.inputHandler.deselect(e.volume);
				};

				this.addEventListener('scene_changed', (e) => {
					this.inputHandler.setScene(e.scene);
					this.clippingTool.setScene(this.scene);

					if (!e.scene.hasEventListener("pointcloud_added", onPointcloudAdded)) {
						e.scene.addEventListener("pointcloud_added", onPointcloudAdded);
					}

					if (!e.scene.hasEventListener("gaussianSplats_added", onGaussianSplatsAdded)) {
						e.scene.addEventListener("gaussianSplats_added", onGaussianSplatsAdded);
					}

					if (!e.scene.hasEventListener("volume_removed", onPointcloudAdded)) {
						e.scene.addEventListener("volume_removed", onVolumeRemoved);
					}

				});

				this.scene.addEventListener("volume_removed", onVolumeRemoved);
				this.scene.addEventListener('pointcloud_added', onPointcloudAdded);
				this.scene.addEventListener("gaussianSplats_added", onGaussianSplatsAdded);
			}

			{ // set defaults
				this.setFOV(60);
				this.setEDLEnabled(false);
				this.setEDLRadius(1.4);
				this.setEDLStrength(0.4);
				this.setEDLOpacity(1.0);
				this.setClipTask(ClipTask.HIGHLIGHT);
				this.setClipMethod(ClipMethod.INSIDE_ANY);
				this.setPointBudget(1 * 1000 * 1000);
				this.setShowBoundingBox(false);
				this.setFreeze(false);
				this.setControls(this.orbitControls);
				this.setBackground('gradient');

				this.scaleFactor = 1;

				this.loadSettingsFromURL();
			}

			// start rendering!
			//if(args.useDefaultRenderLoop === undefined || args.useDefaultRenderLoop === true){
			//requestAnimationFrame(this.loop.bind(this));
			//}

			this.renderer.setAnimationLoop(this.loop.bind(this));

			this.loadGUI = this.loadGUI.bind(this);

			this.annotationTool = new AnnotationTool(this);
			this.measuringTool = new MeasuringTool(this);
			this.profileTool = new ProfileTool(this);
			this.volumeTool = new VolumeTool(this);
			this.polygonVolumeTool = new PolygonVolumeTool(this);

		} catch (e) {
			this.onCrash(e);
		}
	}

	onCrash(error) {

		$(this.renderArea).empty();

		if ($(this.renderArea).find('#potree_failpage').length === 0) {
			let elFailPage = $(`
			<div id="#potree_failpage" class="potree_failpage"> 
				
				<h1>Potree Encountered An Error </h1>

				<p>
				This may happen if your browser or graphics card is not supported.
				<br>
				We recommend to use 
				<a href="https://www.google.com/chrome/browser" target="_blank" style="color:initial">Chrome</a>
				or 
				<a href="https://www.mozilla.org/" target="_blank">Firefox</a>.
				</p>

				<p>
				Please also visit <a href="http://webglreport.com/" target="_blank">webglreport.com</a> and 
				check whether your system supports WebGL.
				</p>
				<p>
				If you are already using one of the recommended browsers and WebGL is enabled, 
				consider filing an issue report at <a href="https://github.com/potree/potree/issues" target="_blank">github</a>,<br>
				including your operating system, graphics card, browser and browser version, as well as the 
				error message below.<br>
				Please do not report errors on unsupported browsers.
				</p>

				<pre id="potree_error_console" style="width: 100%; height: 100%"></pre>
				
			</div>`);

			let elErrorMessage = elFailPage.find('#potree_error_console');
			elErrorMessage.html(error.stack);

			$(this.renderArea).append(elFailPage);
		}

		throw error;
	}

	// ------------------------------------------------------------------------------------
	// Viewer API
	// ------------------------------------------------------------------------------------

	setScene(scene) {
		if (scene === this.scene) {
			return;
		}

		let oldScene = this.scene;
		this.scene = scene;

		this.dispatchEvent({
			type: 'scene_changed',
			oldScene: oldScene,
			scene: scene
		});

		{ // Annotations
			$('.annotation').detach();

			// for(let annotation of this.scene.annotations){
			//	this.renderArea.appendChild(annotation.domElement[0]);
			// }

			this.scene.annotations.traverse(annotation => {
				if (annotation.domElement && annotation.domElement[0]) {
					this.renderArea.appendChild(annotation.domElement[0]);
				}
			});

			if (!this.onAnnotationAdded) {
				this.onAnnotationAdded = e => {
					// console.log("annotation added: " + e.annotation.title);

					e.annotation.traverse(node => {
						// $("#potree_annotation_container").append(node.domElement);
						if (node.domElement && node.domElement[0]) {
							this.renderArea.appendChild(node.domElement[0]);
						}
						node.scene = this.scene;
					});
				};
			}

			if (!this.onAnnotationRemoved) {
				// 标注被移除后必须从 visibleAnnotations 摘掉：remove() 里 dispose() 会把
				// domElement 置空，若实例仍留在集合里，下一帧提交 display 时就会解引用 null。
				// （dispose() 现在也会把 _display 复位、setter 也判空了，这里是第一道防线，
				//  同时避免集合无限增长持有已销毁实例。）
				this.onAnnotationRemoved = e => {
					if (this.visibleAnnotations) {
						this.visibleAnnotations.delete(e.annotation);
					}
				};
			}

			if (oldScene) {
				oldScene.annotations.removeEventListener('annotation_added', this.onAnnotationAdded);
				oldScene.annotations.removeEventListener('annotation_removed', this.onAnnotationRemoved);
			}
			this.scene.annotations.addEventListener('annotation_added', this.onAnnotationAdded);
			this.scene.annotations.addEventListener('annotation_removed', this.onAnnotationRemoved);
		}
	};

	setControls(controls) {
		if (controls !== this.controls) {
			if (this.controls) {
				this.controls.enabled = false;
				this.inputHandler.removeInputListener(this.controls);
			}

			this.controls = controls;
			this.controls.enabled = true;
			this.inputHandler.addInputListener(this.controls);
		}
	}

	getControls() {

		if (this.renderer.xr.isPresenting) {
			return this.vrControls;
		} else {
			return this.controls;
		}

	}

	getMinNodeSize() {
		return this.minNodeSize;
	};

	setMinNodeSize(value) {
		if (this.minNodeSize !== value) {
			this.minNodeSize = value;
			this.dispatchEvent({ 'type': 'minnodesize_changed', 'viewer': this });
		}
	};

	getBackground() {
		return this.background;
	}

	setBackground(bg) {
		if (this.background === bg) {
			return;
		}

		if (bg && bg.indexOf("skybox") !== -1) {
			this.skybox = Utils.loadSkybox(new URL(Potree.resourcePath + '/textures/' + bg + '/').href);
		}

		this.background = bg;
		this.dispatchEvent({ 'type': 'background_changed', 'viewer': this });
	}

	setDescription(value) {
		this.description = value;

		$('#potree_description').html(value);
		//$('#potree_description').text(value);
	}

	getDescription() {
		return this.description;
	}

	setShowBoundingBox(value) {
		if (this.showBoundingBox !== value) {
			this.showBoundingBox = value;
			// 关闭包围盒显示时，清理已创建的 boundingBoxNodes（Box3Helper 含 geometry+material），避免泄漏
			if (!value) {
				for (const pointcloud of this.scene.pointclouds) {
					if (pointcloud.clearBoundingBoxNodes) {
						pointcloud.clearBoundingBoxNodes();
					}
				}
			}
			this.dispatchEvent({ 'type': 'show_boundingbox_changed', 'viewer': this });
		}
	};

	getShowBoundingBox() {
		return this.showBoundingBox;
	};

	setMoveSpeed(value) {
		if (this.moveSpeed !== value) {
			this.moveSpeed = value;
			this.dispatchEvent({ 'type': 'move_speed_changed', 'viewer': this, 'speed': value });
		}
	};

	getMoveSpeed() {
		return this.moveSpeed;
	};

	setWeightClassification(w) {
		for (let i = 0; i < this.scene.pointclouds.length; i++) {
			this.scene.pointclouds[i].material.weightClassification = w;
			this.dispatchEvent({ 'type': 'attribute_weights_changed' + i, 'viewer': this });
		}
	};

	setFreeze(value) {
		value = Boolean(value);
		if (this.freeze !== value) {
			this.freeze = value;
			this.dispatchEvent({ 'type': 'freeze_changed', 'viewer': this });
		}
	};

	getFreeze() {
		return this.freeze;
	};

	getClipTask() {
		return this.clipTask;
	}

	getClipMethod() {
		return this.clipMethod;
	}

	setClipTask(value) {
		if (this.clipTask !== value) {

			this.clipTask = value;

			this.dispatchEvent({
				type: "cliptask_changed",
				viewer: this
			});
		}
	}

	setClipMethod(value) {
		if (this.clipMethod !== value) {

			this.clipMethod = value;

			this.dispatchEvent({
				type: "clipmethod_changed",
				viewer: this
			});
		}
	}

	setElevationGradientRepeat(value) {
		if (this.elevationGradientRepeat !== value) {

			this.elevationGradientRepeat = value;

			this.dispatchEvent({
				type: "elevation_gradient_repeat_changed",
				viewer: this
			});
		}
	}

	setPointBudget(value) {
		if (Potree.pointBudget !== value) {
			Potree.pointBudget = parseInt(value);
			this.dispatchEvent({ 'type': 'point_budget_changed', 'viewer': this });
		}
	};

	getPointBudget() {
		return Potree.pointBudget;
	};

	setShowAnnotations(value) {
		if (this.showAnnotations !== value) {
			this.showAnnotations = value;
			this.dispatchEvent({ 'type': 'show_annotations_changed', 'viewer': this });
		}
	}

	getShowAnnotations() {
		return this.showAnnotations;
	}

	// 视距剔除开关：控制 volume/measurement/profile/annotation 是否按距离隐藏
	setViewDistanceCullingEnabled(value) {
		value = Boolean(value);
		if (this.viewDistanceCullingEnabled !== value) {
			this.viewDistanceCullingEnabled = value;
			this.dispatchEvent({ 'type': 'view_distance_culling_enabled_changed', 'viewer': this });
		}
	}

	getViewDistanceCullingEnabled() {
		return this.viewDistanceCullingEnabled;
	}

	// 视距阈值（场景单位）：相机到对象距离超过该值即隐藏
	setViewDistanceCullingRange(value) {
		value = Number(value);
		if (!isFinite(value) || value < 0) return;
		if (this.viewDistanceCullingRange !== value) {
			this.viewDistanceCullingRange = value;
			this.dispatchEvent({ 'type': 'view_distance_culling_range_changed', 'viewer': this });
		}
	}

	getViewDistanceCullingRange() {
		return this.viewDistanceCullingRange;
	}

	// 标注聚合开关：开启后视距内+视锥内屏幕像素距离小于阈值的标注聚合成一个显示数量的标记点
	setAnnotationClusteringEnabled(value) {
		value = Boolean(value);
		if (this.annotationClusteringEnabled !== value) {
			this.annotationClusteringEnabled = value;
			this.dispatchEvent({ 'type': 'annotation_clustering_enabled_changed', 'viewer': this });
		}
	}

	getAnnotationClusteringEnabled() {
		return this.annotationClusteringEnabled;
	}

	// 聚合像素阈值：屏幕上像素距离小于该值的标注归为同一组（单位 px）
	setAnnotationClusteringPixelThreshold(value) {
		value = Number(value);
		if (!isFinite(value) || value < 1) return;
		if (this.annotationClusteringPixelThreshold !== value) {
			this.annotationClusteringPixelThreshold = value;
			this.dispatchEvent({ 'type': 'annotation_clustering_pixel_threshold_changed', 'viewer': this });
		}
	}

	getAnnotationClusteringPixelThreshold() {
		return this.annotationClusteringPixelThreshold;
	}

	// 近景距离阈值 near（世界单位）：相机到标注距离 <= 此值不聚合，始终显示原始图标
	setAnnotationClusteringMinDistance(value) {
		value = Number(value);
		if (!isFinite(value) || value < 0) return;
		if (this.annotationClusteringMinDistance !== value) {
			this.annotationClusteringMinDistance = value;
			this.dispatchEvent({ 'type': 'annotation_clustering_min_distance_changed', 'viewer': this });
		}
	}

	getAnnotationClusteringMinDistance() {
		return this.annotationClusteringMinDistance;
	}

	// 远景距离阈值 far（世界单位）：聚合点平均距离 >= 此值才叠加屏幕像素合并（第2阶段）
	setAnnotationClusteringFarDistance(value) {
		value = Number(value);
		if (!isFinite(value) || value < 0) return;
		if (this.annotationClusteringFarDistance !== value) {
			this.annotationClusteringFarDistance = value;
			this.dispatchEvent({ 'type': 'annotation_clustering_far_distance_changed', 'viewer': this });
		}
	}

	getAnnotationClusteringFarDistance() {
		return this.annotationClusteringFarDistance;
	}

	// 体素尺寸（世界单位）：0=自动从标注包围盒推导；>0=手动覆盖
	setAnnotationClusteringVoxelSize(value) {
		value = Number(value);
		if (!isFinite(value) || value < 0) return;
		if (this.annotationClusteringVoxelSize !== value) {
			this.annotationClusteringVoxelSize = value;
			this.dispatchEvent({ 'type': 'annotation_clustering_voxel_size_changed', 'viewer': this });
		}
	}

	getAnnotationClusteringVoxelSize() {
		return this.annotationClusteringVoxelSize;
	}

	// 自动体素尺寸的倍率微调（仅在 voxelSize=0 自动模式下生效）
	setAnnotationClusteringVoxelFactor(value) {
		value = Number(value);
		if (!isFinite(value) || value <= 0) return;
		if (this.annotationClusteringVoxelFactor !== value) {
			this.annotationClusteringVoxelFactor = value;
			this.dispatchEvent({ 'type': 'annotation_clustering_voxel_factor_changed', 'viewer': this });
		}
	}

	getAnnotationClusteringVoxelFactor() {
		return this.annotationClusteringVoxelFactor;
	}

	// 设置某类型的聚合覆盖配置（合并到已有配置）。
	// config: { near?, far?, marker?:{background,color,size,borderRadius,fontSize,backgroundImage} }
	setAnnotationClusteringTypeStyle(type, config) {
		if (!type || typeof config !== 'object') return;
		let prev = this.annotationClusteringTypeStyles[type] || {};
		let next = Object.assign({}, prev, config);
		if (config.marker || prev.marker) {
			next.marker = Object.assign({}, prev.marker, config.marker);
		}
		this.annotationClusteringTypeStyles[type] = next;
		// 样式版本号 +1：让已渲染的聚合标记在下一帧强制重刷（否则同类型标记会因短路不更新颜色/尺寸）
		this._clusterStyleVersion = (this._clusterStyleVersion || 0) + 1;
		this.dispatchEvent({ 'type': 'annotation_clustering_type_style_changed', 'viewer': this });
	}

	getAnnotationClusteringTypeStyle(type) {
		return this.annotationClusteringTypeStyles[type] || null;
	}

	getAnnotationClusteringTypeStyles() {
		return this.annotationClusteringTypeStyles;
	}

	// 批量便捷入口：一次性配置聚合相关参数（对外开放）。
	setAnnotationClusteringOptions(opts = {}) {
		if (opts.enabled !== undefined) this.setAnnotationClusteringEnabled(opts.enabled);
		if (opts.pixelThreshold !== undefined) this.setAnnotationClusteringPixelThreshold(opts.pixelThreshold);
		if (opts.near !== undefined) this.setAnnotationClusteringMinDistance(opts.near);
		if (opts.far !== undefined) this.setAnnotationClusteringFarDistance(opts.far);
		if (opts.voxelSize !== undefined) this.setAnnotationClusteringVoxelSize(opts.voxelSize);
		if (opts.voxelFactor !== undefined) this.setAnnotationClusteringVoxelFactor(opts.voxelFactor);
		if (opts.typeStyles && typeof opts.typeStyles === 'object') {
			for (let t of Object.keys(opts.typeStyles)) {
				this.setAnnotationClusteringTypeStyle(t, opts.typeStyles[t]);
			}
		}
	}

	// 取某类型的近景阈值（有覆盖用覆盖，否则回退全局）
	// 注意 isFinite 的约束：near 传 Infinity 会被判为无效配置并回退到全局
	// annotationClusteringMinDistance，效果与"该类型永不聚合"的意图正好相反。
	// 要让某类型实际上不参与聚合，传一个巨大的有限值（如 1e9）。_getTypeFar 同理。
	_getTypeNear(type) {
		let s = this.annotationClusteringTypeStyles[type];
		return (s && isFinite(s.near)) ? s.near : this.annotationClusteringMinDistance;
	}

	// 取某类型的远景阈值（有覆盖用覆盖，否则回退全局）
	_getTypeFar(type) {
		let s = this.annotationClusteringTypeStyles[type];
		return (s && isFinite(s.far)) ? s.far : this.annotationClusteringFarDistance;
	}

	setDEMCollisionsEnabled(value) {
		if (this.useDEMCollisions !== value) {
			this.useDEMCollisions = value;
			this.dispatchEvent({ 'type': 'use_demcollisions_changed', 'viewer': this });
		};
	};

	getDEMCollisionsEnabled() {
		return this.useDEMCollisions;
	};

	setEDLEnabled(value) {
		value = Boolean(value) && Features.SHADER_EDL.isSupported();

		if (this.useEDL !== value) {
			this.useEDL = value;
			this.dispatchEvent({ 'type': 'use_edl_changed', 'viewer': this });
		}
	};

	getEDLEnabled() {
		return this.useEDL;
	};

	setEDLRadius(value) {
		if (this.edlRadius !== value) {
			this.edlRadius = value;
			this.dispatchEvent({ 'type': 'edl_radius_changed', 'viewer': this });
		}
	};

	getEDLRadius() {
		return this.edlRadius;
	};

	setEDLStrength(value) {
		if (this.edlStrength !== value) {
			this.edlStrength = value;
			this.dispatchEvent({ 'type': 'edl_strength_changed', 'viewer': this });
		}
	};

	getEDLStrength() {
		return this.edlStrength;
	};

	setEDLOpacity(value) {
		if (this.edlOpacity !== value) {
			this.edlOpacity = value;
			this.dispatchEvent({ 'type': 'edl_opacity_changed', 'viewer': this });
		}
	};

	getEDLOpacity() {
		return this.edlOpacity;
	};

	setFOV(value) {
		if (this.fov !== value) {
			this.fov = value;
			this.dispatchEvent({ 'type': 'fov_changed', 'viewer': this });
		}
	};

	getFOV() {
		return this.fov;
	};

	disableAnnotations() {
		this.scene.annotations.traverse(annotation => {
			// dispose() 后 domElement 为 null，判空避免遍历到已销毁但仍挂在树上的节点时崩溃
			if (annotation.domElement) {
				annotation.domElement.css('pointer-events', 'none');
			}

			// return annotation.visible;
		});
	};

	enableAnnotations() {
		this.scene.annotations.traverse(annotation => {
			if (annotation.domElement) {
				annotation.domElement.css('pointer-events', 'auto');
			}

			// return annotation.visible;
		});
	}

	setClassifications(classifications) {
		this.classifications = classifications;

		this.dispatchEvent({ 'type': 'classifications_changed', 'viewer': this });
	}

	setClassificationVisibility(key, value) {
		if (!this.classifications[key]) {
			this.classifications[key] = { visible: value, name: 'no name' };
			this.dispatchEvent({ 'type': 'classification_visibility_changed', 'viewer': this });
		} else if (this.classifications[key].visible !== value) {
			this.classifications[key].visible = value;
			this.dispatchEvent({ 'type': 'classification_visibility_changed', 'viewer': this });
		}
	}

	toggleAllClassificationsVisibility() {

		let numVisible = 0;
		let numItems = 0;
		for (const key of Object.keys(this.classifications)) {
			if (this.classifications[key].visible) {
				numVisible++;
			}
			numItems++;
		}

		let visible = true;
		if (numVisible === numItems) {
			visible = false;
		}

		let somethingChanged = false;

		for (const key of Object.keys(this.classifications)) {
			if (this.classifications[key].visible !== visible) {
				this.classifications[key].visible = visible;
				somethingChanged = true;
			}
		}

		if (somethingChanged) {
			this.dispatchEvent({ 'type': 'classification_visibility_changed', 'viewer': this });
		}
	}

	setFilterReturnNumberRange(from, to) {
		this.filterReturnNumberRange = [from, to];
		this.dispatchEvent({ 'type': 'filter_return_number_range_changed', 'viewer': this });
	}

	setFilterNumberOfReturnsRange(from, to) {
		this.filterNumberOfReturnsRange = [from, to];
		this.dispatchEvent({ 'type': 'filter_number_of_returns_range_changed', 'viewer': this });
	}

	setFilterGPSTimeRange(from, to) {
		this.filterGPSTimeRange = [from, to];
		this.dispatchEvent({ 'type': 'filter_gps_time_range_changed', 'viewer': this });
	}

	setFilterPointSourceIDRange(from, to) {
		this.filterPointSourceIDRange = [from, to]
		this.dispatchEvent({ 'type': 'filter_point_source_id_range_changed', 'viewer': this });
	}

	setLengthUnit(value) {
		switch (value) {
			case 'm':
				this.lengthUnit = LengthUnits.METER;
				this.lengthUnitDisplay = LengthUnits.METER;
				break;
			case 'ft':
				this.lengthUnit = LengthUnits.FEET;
				this.lengthUnitDisplay = LengthUnits.FEET;
				break;
			case 'in':
				this.lengthUnit = LengthUnits.INCH;
				this.lengthUnitDisplay = LengthUnits.INCH;
				break;
		}

		this.dispatchEvent({ 'type': 'length_unit_changed', 'viewer': this, value: value });
	};

	setLengthUnitAndDisplayUnit(lengthUnitValue, lengthUnitDisplayValue) {
		switch (lengthUnitValue) {
			case 'm':
				this.lengthUnit = LengthUnits.METER;
				break;
			case 'ft':
				this.lengthUnit = LengthUnits.FEET;
				break;
			case 'in':
				this.lengthUnit = LengthUnits.INCH;
				break;
		}

		switch (lengthUnitDisplayValue) {
			case 'm':
				this.lengthUnitDisplay = LengthUnits.METER;
				break;
			case 'ft':
				this.lengthUnitDisplay = LengthUnits.FEET;
				break;
			case 'in':
				this.lengthUnitDisplay = LengthUnits.INCH;
				break;
		}

		this.dispatchEvent({ 'type': 'length_unit_changed', 'viewer': this, value: lengthUnitValue });
	};

	zoomTo(node, factor, animationDuration = 0) {
		let view = this.scene.view;

		let camera = this.scene.cameraP.clone();
		camera.rotation.copy(this.scene.cameraP.rotation);
		camera.rotation.order = "ZXY";
		camera.rotation.x = Math.PI / 2 + view.pitch;
		camera.rotation.z = view.yaw;
		camera.updateMatrix();
		camera.updateMatrixWorld();
		camera.zoomTo(node, factor);

		let bs;
		if (node.boundingSphere) {
			bs = node.boundingSphere;
		} else if (node.geometry && node.geometry.boundingSphere) {
			bs = node.geometry.boundingSphere;
		} else {
			bs = node.boundingBox.getBoundingSphere(new THREE.Sphere());
		}
		bs = bs.clone().applyMatrix4(node.matrixWorld);

		let startPosition = view.position.clone();
		let endPosition = camera.position.clone();
		let startTarget = view.getPivot();
		let endTarget = bs.center;
		let startRadius = view.radius;
		let endRadius = endPosition.distanceTo(endTarget);

		let easing = TWEEN.Easing.Quartic.Out;

		{ // animate camera position
			let pos = startPosition.clone();
			let tween = new TWEEN.Tween(pos).to(endPosition, animationDuration);
			tween.easing(easing);

			tween.onUpdate(() => {
				view.position.copy(pos);
			});

			tween.start();
		}

		{ // animate camera target
			let target = startTarget.clone();
			let tween = new TWEEN.Tween(target).to(endTarget, animationDuration);
			tween.easing(easing);
			tween.onUpdate(() => {
				view.lookAt(target);
			});
			tween.onComplete(() => {
				view.lookAt(target);
				this.dispatchEvent({ type: 'focusing_finished', target: this });
			});

			this.dispatchEvent({ type: 'focusing_started', target: this });
			tween.start();
		}
	};

	moveToGpsTimeVicinity(time) {
		const result = Potree.Utils.findClosestGpsTime(time, viewer);

		const box = result.node.pointcloud.deepestNodeAt(result.position).getBoundingBox();
		const diameter = box.min.distanceTo(box.max);

		const camera = this.scene.getActiveCamera();
		const offset = camera.getWorldDirection(new THREE.Vector3()).multiplyScalar(diameter);
		const newCamPos = result.position.clone().sub(offset);

		this.scene.view.position.copy(newCamPos);
		this.scene.view.lookAt(result.position);
	}

	showAbout() {
		$(function () {
			$('#about-panel').dialog();
		});
	};

	getBoundingBox(pointclouds) {
		return this.scene.getBoundingBox(pointclouds);
	};

	/**
	 * CSS3D 叠加层，懒创建。用于 YDBoxVolume 的网页资源(id=9)：把真 iframe 按包围盒
	 * 正面的世界位姿摆进 3D 场景，鼠标可直接操作网页。
	 *
	 * 注意 iframe 是 DOM，不进 WebGL 管线，与点云没有共享深度缓冲，因此
	 * 【无法被点云/高斯遮挡】。详见 src/viewer/CSS3DLayer.js 头部注释。
	 *
	 * 没有网页资源时该层从不创建，零开销。
	 */
	getCSS3DLayer() {
		if (!this._css3dLayer) {
			this._css3dLayer = new CSS3DLayer(this);
		}
		return this._css3dLayer;
	}

	/**
	 * 打洞式遮挡层（懒创建）。与 CSS3DLayer 配套：CSS3DLayer 把 iframe 放在 canvas 之下，
	 * HolePunchLayer 在 render.pass.depth 时用 vec4(0,0,0,0) + NoBlending + depthTest 画盒子正面，
	 * 把 canvas 对应像素 alpha 覆写为 0 透出 iframe，实现逐像素遮挡。
	 * 无网页资源时该层从不创建，零开销。详见 src/viewer/HolePunchLayer.js。
	 */
	getHolePunchLayer() {
		if (!this._holePunchLayer) {
			this._holePunchLayer = new HolePunchLayer(this);
		}
		return this._holePunchLayer;
	}

	getGaussianSplatsBoundingBox(gaussianSplats) {
		return this.scene.getGaussianSplatsBoundingBox(gaussianSplats)
	}

	getGpsTimeExtent() {
		const range = [Infinity, -Infinity];

		for (const pointcloud of this.scene.pointclouds) {
			const attributes = pointcloud.pcoGeometry.pointAttributes.attributes;
			const aGpsTime = attributes.find(a => a.name === "gps-time");

			if (aGpsTime) {
				range[0] = Math.min(range[0], aGpsTime.range[0]);
				range[1] = Math.max(range[1], aGpsTime.range[1]);
			}
		}

		return range;
	}

	fitToScreen(factor = 1, animationDuration = 0) {
		let box = new THREE.Box3()
		if (this.sceneShowModel == ShowMode.GaussianSplats) {
			box = this.getGaussianSplatsBoundingBox(this.scene.gaussianSplats);
		} else {
			box = this.getBoundingBox(this.scene.pointclouds);
		}
		let node = new THREE.Object3D();
		node.boundingBox = box;

		this.zoomTo(node, factor, animationDuration);
		this.controls.stop();
	};

	toggleNavigationCube() {
		this.navigationCube.visible = !this.navigationCube.visible;
	}

	setView(view) {
		if (!view) return;

		switch (view) {
			case "F":
				this.setFrontView();
				break;
			case "B":
				this.setBackView();
				break;
			case "L":
				this.setLeftView();
				break;
			case "R":
				this.setRightView();
				break;
			case "U":
				this.setTopView();
				break;
			case "D":
				this.setBottomView();
				break;
		}
	}

	setTopView(factor) {
		this.scene.view.yaw = 0;
		this.scene.view.pitch = -Math.PI / 2;

		this.fitToScreen(factor);
	};

	setBottomView() {
		this.scene.view.yaw = -Math.PI;
		this.scene.view.pitch = Math.PI / 2;

		this.fitToScreen();
	};

	setFrontView() {
		this.scene.view.yaw = 0;
		this.scene.view.pitch = 0;

		this.fitToScreen();
	};

	setBackView() {
		this.scene.view.yaw = Math.PI;
		this.scene.view.pitch = 0;

		this.fitToScreen();
	};

	setLeftView() {
		this.scene.view.yaw = -Math.PI / 2;
		this.scene.view.pitch = 0;

		this.fitToScreen();
	};

	setRightView() {
		this.scene.view.yaw = Math.PI / 2;
		this.scene.view.pitch = 0;

		this.fitToScreen();
	};

	flipYZ() {
		this.isFlipYZ = !this.isFlipYZ;

		// TODO flipyz
		console.log('TODO');
	}

	setCameraMode(mode) {
		this.scene.cameraMode = mode;

		for (let pointcloud of this.scene.pointclouds) {
			pointcloud.material.useOrthographicCamera = mode == CameraMode.ORTHOGRAPHIC;
		}
	}

	getProjection() {
		const pointcloud = this.scene.pointclouds[0];

		if (pointcloud) {
			return pointcloud.projection;
		} else {
			return null;
		}
	}
	// 需要点云和3DGS都加载了
	setShowModel(mode) {
		this.sceneShowModel = mode
	}

	getShowModel() {
		return this.ShowMode
	}

	async loadProject(url) {

		const response = await fetch(url);

		const text = await response.text();
		const json = JSON5.parse(text);
		// const json = JSON.parse(text);

		if (json.type === "Potree") {
			Potree.loadProject(viewer, json);
		}

		//Potree.loadProject(this, url);
	}

	saveProject() {
		return Potree.saveProject(this);
	}

	loadSettingsFromURL() {
		if (Utils.getParameterByName("pointSize")) {
			this.setPointSize(parseFloat(Utils.getParameterByName("pointSize")));
		}

		if (Utils.getParameterByName("FOV")) {
			this.setFOV(parseFloat(Utils.getParameterByName("FOV")));
		}

		if (Utils.getParameterByName("opacity")) {
			this.setOpacity(parseFloat(Utils.getParameterByName("opacity")));
		}

		if (Utils.getParameterByName("edlEnabled")) {
			let enabled = Utils.getParameterByName("edlEnabled") === "true";
			this.setEDLEnabled(enabled);
		}

		if (Utils.getParameterByName('edlRadius')) {
			this.setEDLRadius(parseFloat(Utils.getParameterByName('edlRadius')));
		}

		if (Utils.getParameterByName('edlStrength')) {
			this.setEDLStrength(parseFloat(Utils.getParameterByName('edlStrength')));
		}

		if (Utils.getParameterByName('pointBudget')) {
			this.setPointBudget(parseFloat(Utils.getParameterByName('pointBudget')));
		}

		if (Utils.getParameterByName('showBoundingBox')) {
			let enabled = Utils.getParameterByName('showBoundingBox') === 'true';
			if (enabled) {
				this.setShowBoundingBox(true);
			} else {
				this.setShowBoundingBox(false);
			}
		}

		if (Utils.getParameterByName('material')) {
			let material = Utils.getParameterByName('material');
			this.setMaterial(material);
		}

		if (Utils.getParameterByName('pointSizing')) {
			let sizing = Utils.getParameterByName('pointSizing');
			this.setPointSizing(sizing);
		}

		if (Utils.getParameterByName('quality')) {
			let quality = Utils.getParameterByName('quality');
			this.setQuality(quality);
		}

		if (Utils.getParameterByName('position')) {
			let value = Utils.getParameterByName('position');
			value = value.replace('[', '').replace(']', '');
			let tokens = value.split(';');
			let x = parseFloat(tokens[0]);
			let y = parseFloat(tokens[1]);
			let z = parseFloat(tokens[2]);

			this.scene.view.position.set(x, y, z);
		}

		if (Utils.getParameterByName('target')) {
			let value = Utils.getParameterByName('target');
			value = value.replace('[', '').replace(']', '');
			let tokens = value.split(';');
			let x = parseFloat(tokens[0]);
			let y = parseFloat(tokens[1]);
			let z = parseFloat(tokens[2]);

			this.scene.view.lookAt(new THREE.Vector3(x, y, z));
		}

		if (Utils.getParameterByName('background')) {
			let value = Utils.getParameterByName('background');
			this.setBackground(value);
		}

		// if(Utils.getParameterByName("elevationRange")){
		//	let value = Utils.getParameterByName("elevationRange");
		//	value = value.replace("[", "").replace("]", "");
		//	let tokens = value.split(";");
		//	let x = parseFloat(tokens[0]);
		//	let y = parseFloat(tokens[1]);
		//
		//	this.setElevationRange(x, y);
		//	//this.scene.view.target.set(x, y, z);
		// }
	};

	// ------------------------------------------------------------------------------------
	// Viewer Internals
	// ------------------------------------------------------------------------------------

	createControls() {
		{ // create FIRST PERSON CONTROLS
			this.fpControls = new FirstPersonControls(this);
			this.fpControls.enabled = false;
			this.fpControls.addEventListener('start', this.disableAnnotations.bind(this));
			this.fpControls.addEventListener('end', this.enableAnnotations.bind(this));
		}

		// { // create GEO CONTROLS
		//	this.geoControls = new GeoControls(this.scene.camera, this.renderer.domElement);
		//	this.geoControls.enabled = false;
		//	this.geoControls.addEventListener("start", this.disableAnnotations.bind(this));
		//	this.geoControls.addEventListener("end", this.enableAnnotations.bind(this));
		//	this.geoControls.addEventListener("move_speed_changed", (event) => {
		//		this.setMoveSpeed(this.geoControls.moveSpeed);
		//	});
		// }

		{ // create ORBIT CONTROLS
			this.orbitControls = new OrbitControls(this);
			this.orbitControls.enabled = false;
			this.orbitControls.addEventListener('start', this.disableAnnotations.bind(this));
			this.orbitControls.addEventListener('end', this.enableAnnotations.bind(this));
		}

		{ // create EARTH CONTROLS
			this.earthControls = new EarthControls(this);
			this.earthControls.enabled = false;
			this.earthControls.addEventListener('start', this.disableAnnotations.bind(this));
			this.earthControls.addEventListener('end', this.enableAnnotations.bind(this));
		}

		{ // create DEVICE ORIENTATION CONTROLS
			this.deviceControls = new DeviceOrientationControls(this);
			this.deviceControls.enabled = false;
			this.deviceControls.addEventListener('start', this.disableAnnotations.bind(this));
			this.deviceControls.addEventListener('end', this.enableAnnotations.bind(this));
		}

		{ // create VR CONTROLS
			this.vrControls = new VRControls(this);
			this.vrControls.enabled = false;
			this.vrControls.addEventListener('start', this.disableAnnotations.bind(this));
			this.vrControls.addEventListener('end', this.enableAnnotations.bind(this));
		}


	};

	toggleSidebar() {
		let renderArea = $('#potree_render_area');
		let isVisible = renderArea.css('left') !== '0px';

		if (isVisible) {
			renderArea.css('left', '0px');
		} else {
			renderArea.css('left', '300px');
		}
	};

	toggleMap() {
		// let map = $('#potree_map');
		// map.toggle(100);

		if (this.mapView) {
			this.mapView.toggle();
		}
	};

	onGUILoaded(callback) {
		if (this.guiLoaded) {
			callback();
		} else {
			this.guiLoadTasks.push(callback);
		}
	}

	promiseGuiLoaded() {
		return new Promise(resolve => {

			if (this.guiLoaded) {
				resolve();
			} else {
				this.guiLoadTasks.push(resolve);
			}

		});
	}

	loadGUI(callback) {

		if (callback) {
			this.onGUILoaded(callback);
		}

		let viewer = this;
		let sidebarContainer = $('#potree_sidebar_container');
		sidebarContainer.load(new URL(Potree.scriptPath + '/sidebar.html').href, () => {
			sidebarContainer.css('width', '300px');
			sidebarContainer.css('height', '100%');

			let imgMenuToggle = document.createElement('img');
			imgMenuToggle.src = new URL(Potree.resourcePath + '/icons/menu_button.svg').href;
			imgMenuToggle.onclick = this.toggleSidebar;
			imgMenuToggle.classList.add('potree_menu_toggle');

			let imgMapToggle = document.createElement('img');
			imgMapToggle.src = new URL(Potree.resourcePath + '/icons/map_icon.png').href;
			imgMapToggle.style.display = 'none';
			imgMapToggle.onclick = e => { this.toggleMap(); };
			imgMapToggle.id = 'potree_map_toggle';



			let elButtons = $("#potree_quick_buttons").get(0);

			elButtons.append(imgMenuToggle);
			elButtons.append(imgMapToggle);

			// 重构178 VRButton.createButton 调用方式变更（核心强制项）onStart改成sessionstart有风险。暂时这样
			// VRButton.createButton(this.renderer).then(vrButton => {

			// 	if (vrButton == null) {
			// 		console.log("VR not supported or active.");

			// 		return;
			// 	}

			// 	this.renderer.xr.enabled = true;

			// 	let element = vrButton.element;

			// 	element.style.position = "";
			// 	element.style.bottom = "";
			// 	element.style.left = "";
			// 	element.style.margin = "4px";
			// 	element.style.fontSize = "100%";
			// 	element.style.width = "2.5em";
			// 	element.style.height = "2.5em";
			// 	element.style.padding = "0";
			// 	element.style.textShadow = "black 2px 2px 2px";
			// 	element.style.display = "block";

			// 	elButtons.append(element);

			// 	vrButton.onStart(() => {
			// 		this.dispatchEvent({ type: "vr_start" });
			// 	});

			// 	vrButton.onEnd(() => {
			// 		this.dispatchEvent({ type: "vr_end" });
			// 	});
			// });

			// navigator.xr 在非 HTTPS 或不支持 WebXR 的浏览器上为 undefined，
			// 直接调 isSessionSupported 会抛 TypeError 中断 Viewer 初始化。
			if (!navigator.xr || typeof navigator.xr.isSessionSupported !== 'function') {
				console.log("WebXR not available (requires HTTPS + supported browser). VR controls disabled.");
			} else {
			navigator.xr.isSessionSupported('immersive-vr').then(function (supported) {
				if (supported) {
					const vrButton = VRButton.createButton(this.renderer);
					if (vrButton == null) {
						console.log("VR not supported or active.");
					} else {
						this.renderer.xr.enabled = true;

						// 新版本直接操作返回的 DOM 元素（无 .element 嵌套）
						const element = vrButton;
						element.style.position = "";
						element.style.bottom = "";
						element.style.left = "";
						element.style.margin = "4px";
						element.style.fontSize = "100%";
						element.style.width = "2.5em";
						element.style.height = "2.5em";
						element.style.padding = "0";
						element.style.textShadow = "black 2px 2px 2px";
						element.style.display = "block";

						elButtons.append(element);

						// 替换原 onStart/onEnd：监听 XR 会话事件
						this.renderer.xr.addEventListener('sessionstart', () => {
							this.dispatchEvent({ type: "vr_start" });
						});
						this.renderer.xr.addEventListener('sessionend', () => {
							this.dispatchEvent({ type: "vr_end" });
						});
					}
				}
			})
			} // end if (navigator.xr)

			this.mapView = new MapView(this);
			this.mapView.init();

			i18n.init({
				lng: 'en',
				resGetPath: Potree.resourcePath + '/lang/__lng__/__ns__.json',
				preload: ['en', 'fr', 'de', 'jp', 'se', 'es', 'zh', 'it'],
				getAsync: true,
				debug: false
			}, function (t) {
				// Start translation once everything is loaded
				$('body').i18n();
			});

			$(() => {
				//initSidebar(this);
				let sidebar = new Sidebar(this);
				sidebar.init();

				this.sidebar = sidebar;

				//if (callback) {
				//	$(callback);
				//}

				let elProfile = $('<div>').load(new URL(Potree.scriptPath + '/profile.html').href, () => {
					$(document.body).append(elProfile.children());
					this.profileWindow = new ProfileWindow(this);
					this.profileWindowController = new ProfileWindowController(this);

					$('#profile_window').draggable({
						handle: $('#profile_titlebar'),
						containment: $(document.body)
					});
					$('#profile_window').resizable({
						containment: $(document.body),
						handles: 'n, e, s, w'
					});

					$(() => {
						this.guiLoaded = true;
						for (let task of this.guiLoadTasks) {
							task();
						}

					});
				});



			});


		});

		return this.promiseGuiLoaded();
	}

	setLanguage(lang) {
		i18n.setLng(lang);
		$('body').i18n();
	}

	setServer(server) {
		this.server = server;
	}

	initDragAndDrop() {
		function allowDrag(e) {
			e.dataTransfer.dropEffect = 'copy';
			e.preventDefault();
		}

		let dropHandler = async (event) => {
			console.log(event);
			event.preventDefault();

			for (const item of event.dataTransfer.items) {
				console.log(item);

				if (item.kind !== "file") {
					continue;
				}

				const file = item.getAsFile();

				const isJson5 = file.name.toLowerCase().endsWith(".json5");
				const isGeoPackage = file.name.toLowerCase().endsWith(".gpkg");

				if (isJson5) {
					try {

						const text = await file.text();
						const json = JSON5.parse(text);

						if (json.type === "Potree") {
							Potree.loadProject(viewer, json);
						}
					} catch (e) {
						console.error("failed to parse the dropped file as JSON");
						console.error(e);
					}
				} else if (isGeoPackage) {
					const hasPointcloud = viewer.scene.pointclouds.length > 0;

					if (!hasPointcloud) {
						let msg = "At least one point cloud is needed that specifies the ";
						msg += "coordinate reference system before loading vector data.";
						console.error(msg);
					} else {

						proj4.defs("WGS84", "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs");
						proj4.defs("pointcloud", this.getProjection());
						let transform = proj4("WGS84", "pointcloud");

						const buffer = await file.arrayBuffer();

						const params = {
							transform: transform,
							source: file.name,
						};

						const geo = await Potree.GeoPackageLoader.loadBuffer(buffer, params);
						viewer.scene.addGeopackage(geo);
					}
				}

			}
		};


		$("body")[0].addEventListener("dragenter", allowDrag);
		$("body")[0].addEventListener("dragover", allowDrag);
		$("body")[0].addEventListener("drop", dropHandler);
	}

	initThree() {

		console.log(`initializing three.js ${THREE.REVISION}`);

		let width = this.renderArea.clientWidth;
		let height = this.renderArea.clientHeight;

		let contextAttributes = {
			alpha: true,
			depth: true,
			stencil: false,
			antialias: false,
			//premultipliedAlpha: _premultipliedAlpha,
			preserveDrawingBuffer: true,
			powerPreference: "high-performance",
		};

		// let contextAttributes = {
		// 	alpha: false,
		// 	preserveDrawingBuffer: true,
		// };

		// let contextAttributes = {
		// 	alpha: false,
		// 	preserveDrawingBuffer: true,
		// };

		let canvas = document.createElement("canvas");

		let context = canvas.getContext('webgl2', contextAttributes);

		this.renderer = new THREE.WebGLRenderer({
			alpha: true,
			premultipliedAlpha: false,
			canvas: canvas,
			context: context
		});
		this.renderer.sortObjects = false;
		this.renderer.setSize(width, height);
		this.renderer.autoClear = false;
		this.renderArea.appendChild(this.renderer.domElement);
		this.renderer.domElement.tabIndex = '2222';
		this.renderer.domElement.style.position = 'absolute';
		this.renderer.domElement.addEventListener('mousedown', () => {
			this.renderer.domElement.focus();
		});
		//this.renderer.domElement.focus();
		this.isShot = false;
		// NOTE: If extension errors occur, pass the string into this.renderer.extensions.get(x) before enabling
		// enable frag_depth extension for the interpolation shader, if available
		let gl = this.renderer.getContext();
		gl.getExtension('EXT_frag_depth');
		gl.getExtension('WEBGL_depth_texture');
		gl.getExtension('WEBGL_color_buffer_float'); 	// Enable explicitly for more portability, EXT_color_buffer_float is the proper name in WebGL 2

		if (gl.createVertexArray == null) {
			let extVAO = gl.getExtension('OES_vertex_array_object');

			if (!extVAO) {
				throw new Error("OES_vertex_array_object extension not supported");
			}

			gl.createVertexArray = extVAO.createVertexArrayOES.bind(extVAO);
			gl.bindVertexArray = extVAO.bindVertexArrayOES.bind(extVAO);
		}

		// 如果不支持扩展，则使用标准的着色语言版本
		const glslVersion = gl.getParameter(gl.SHADING_LANGUAGE_VERSION);
		console.log(`GLSL Version: ${glslVersion}`);
	}

	// 视距剔除：遍历场景中的 volume/measurement/profile，超出阈值距离的隐藏、回到范围内的恢复。
	// annotation 是 DOM 标签，其距离剔除并入 updateAnnotations() 处理，这里不涉及。
	// 通过 _distanceCulled / _visibleBeforeCull 记忆用户原可见状态，剔除释放时精确还原，避免与手动开关冲突。
	updateViewDistanceCulling(camera) {
		const enabled = this.viewDistanceCullingEnabled;
		const range = this.viewDistanceCullingRange;
		const camPos = camera.getWorldPosition(new THREE.Vector3());
		const tmp = new THREE.Vector3();

		// 从对象取代表世界坐标：Volume 用中心；Measure/Profile 用其 points 的质心
		const centroidOfPoints = (points) => {
			if (!points || points.length === 0) return null;
			const c = new THREE.Vector3();
			for (const p of points) {
				// Measure.points 元素为 { position: Vector3 }，Profile.points 元素为 Vector3
				const v = (p && p.position) ? p.position : p;
				if (v && v.isVector3) c.add(v);
			}
			return c.multiplyScalar(1 / points.length);
		};

		const apply = (obj, worldPos) => {
			if (!obj) return;
			const cull = enabled && worldPos != null && camPos.distanceTo(worldPos) > range;
			if (cull) {
				if (!obj._distanceCulled) {
					obj._distanceCulled = true;
					obj._visibleBeforeCull = obj.visible;
					obj.visible = false;
				}
			} else if (obj._distanceCulled) {
				obj._distanceCulled = false;
				obj.visible = obj._visibleBeforeCull;
			}
		};

		for (const v of this.scene.volumes) {
			apply(v, v.getWorldPosition(tmp).clone());
		}
		for (const m of this.scene.measurements) {
			apply(m, centroidOfPoints(m.points));
		}
		for (const p of this.scene.profiles) {
			apply(p, centroidOfPoints(p.points));
		}
	}

	updateAnnotations() {

		if (!this.visibleAnnotations) {
			this.visibleAnnotations = new Set();
		}

		this.scene.annotations.updateBounds();
		this.scene.cameraP.updateMatrixWorld();
		this.scene.cameraO.updateMatrixWorld();

		// 复用临时对象，避免每帧每标注 new Vector3/Sphere/Vector2 造成 GC 压力
		if (!this._annoTmpPos) {
			this._annoTmpPos = new THREE.Vector3();
			this._annoTmpSphere = new THREE.Sphere();
			this._annoTmpScreen = new THREE.Vector3();
			this._annoTmpSize = new THREE.Vector2();
		}
		let tmpPos = this._annoTmpPos;
		let tmpSphere = this._annoTmpSphere;
		let screenPos = this._annoTmpScreen;
		let renderAreaSize = this.renderer.getSize(this._annoTmpSize);

		let viewer = this;
		let activeCamera = this.scene.getActiveCamera();
		let camPos = this.scene.cameraP.position;
		// 聚合开启时，annotation 不再按视距剔除隐藏——远处标注要交给聚合按距离分层处理，
		// 否则会在进聚合前就被剔除，导致远处永远聚不起来。
		// （视距剔除对 volume/measurement/profile 仍单独生效，见 updateViewDistanceCulling）
		let cullingEnabled = this.viewDistanceCullingEnabled && !this.annotationClusteringEnabled;
		let cullingRange = this.viewDistanceCullingRange;
		let cellSize = this.annotationClusteringPixelThreshold;

		let visibleNow = [];
		// 本帧遍历真正"触达"过的标注（进入了视距+投影判断的那批）。
		// 与 visibleNow 的区别：还包含被展开的父节点、以及视锥外的标注 —— 凡是 set expand
		// 可能写过 display 的节点都要在这里登记，提交阶段才能把它们无条件压回正确值。
		let touchedNow = new Set();
		this.scene.annotations.traverse(annotation => {

			if (annotation === this.scene.annotations) {
				return true;
			}

			if (!annotation.visible) {
				return false;
			}

			annotation.scene = this.scene;

			// 子树包围球（复用临时对象）
			let bs = annotation.boundingBox.getBoundingSphere(tmpSphere);

			// 自身世界坐标（复用临时对象，避免 clone）
			let position = annotation.position;
			if (position) {
				tmpPos.copy(position).add(annotation.offset);
			} else {
				tmpPos.copy(bs.center);
			}

			let distance = camPos.distanceTo(tmpPos);
			let withinRange = !cullingEnabled || distance <= cullingRange;

			// 视距外的标注：跳过投影/DOM 写入/折叠判断（反正不会进 visibleNow 显示），
			// 但仍需递归子节点（子节点可能在视距内），故返回 true。
			// 这是把每帧 JS 工作量从"全部标注"降到"视距内标注"量级的关键。
			if (!withinRange) {
				return true;
			}

			// 投影到屏幕（复用临时对象）
			screenPos.copy(tmpPos).project(activeCamera);
			let inFrustum = (screenPos.z >= -1 && screenPos.z <= 1);

			// 登记为本帧触达：下面可能通过 annotation.expand 间接写 display（见 set expand），
			// 提交阶段要按聚合结果把它压回去，所以视锥内外都得登记。
			touchedNow.add(annotation);

			// 仅视锥内的标注才写 DOM 定位，视锥外跳过 css 写入
			if (inFrustum) {
				screenPos.x = renderAreaSize.x * (screenPos.x + 1) / 2;
				screenPos.y = renderAreaSize.y * (1 - (screenPos.y + 1) / 2);

				let element = annotation.domElement;
				// dispose() 后 domElement 为 null，但实例可能还挂在标注树上（业务侧直接调
				// dispose 而非 parent.remove 时），跳过定位避免每帧解引用 null 崩溃
				if (element && element[0]) {
					// 用 CSS 自定义属性承载位移（配合 CSS 里的 translate3d(var(--anno-x),var(--anno-y),0)），
					// 替代 left/top，避免触发 layout reflow，只走 GPU 合成层
					element[0].style.setProperty('--anno-x', screenPos.x + 'px');
					element[0].style.setProperty('--anno-y', screenPos.y + 'px');

					let zIndex = 10000000 - distance * (10000000 / this.scene.cameraP.far);
					if (annotation.descriptionVisible) {
						zIndex += 10000000;
					}
					element.css("z-index", parseInt(zIndex));
				}
			}

			if (annotation.children.length > 0) {
				// SCREEN SIZE：仅折叠判断需要，叶子节点不再计算
				let screenSize = 0;
				let radius = bs.radius;
				if (viewer.scene.cameraMode == CameraMode.PERSPECTIVE) {
					let fov = Math.PI * viewer.scene.cameraP.fov / 180;
					let slope = Math.tan(fov / 2.0);
					let projFactor = 0.5 * renderAreaSize.y / (slope * distance);
					screenSize = radius * projFactor;
				} else {
					screenSize = Utils.projectedRadiusOrtho(radius, viewer.scene.cameraO.projectionMatrix, renderAreaSize.x, renderAreaSize.y);
				}

				let expand = screenSize > annotation.collapseThreshold || annotation.boundingBox.containsPoint(activeCamera.position);
				annotation.expand = expand;

				if (!expand && inFrustum) {
					// 暂存屏幕坐标、世界坐标、距离，供聚合 pass 使用
					annotation._clusterX = screenPos.x;
					annotation._clusterY = screenPos.y;
					annotation._clusterWX = tmpPos.x;
					annotation._clusterWY = tmpPos.y;
					annotation._clusterWZ = tmpPos.z;
					annotation._clusterDist = distance;
					annotation._clusterType = annotation.type;
					visibleNow.push(annotation);
				}

				return expand;
			} else {
				if (inFrustum) {
					// 暂存屏幕坐标、世界坐标、距离，供聚合 pass 使用
					annotation._clusterX = screenPos.x;
					annotation._clusterY = screenPos.y;
					annotation._clusterWX = tmpPos.x;
					annotation._clusterWY = tmpPos.y;
					annotation._clusterWZ = tmpPos.z;
					annotation._clusterDist = distance;
					annotation._clusterType = annotation.type;
					visibleNow.push(annotation);
				}
			}

		});

		// ===== 聚合 pass（工业级组合）：距离分层 → 3D体素分箱 → 远景屏幕像素二次过滤 =====
		let clusterList = [];   // 本帧要显示的聚合点 { x, y, count, wx, wy, wz, dist, members }
		let displaySet;         // 本帧实际 display=true 的标注集合

		if (this.annotationClusteringEnabled && visibleNow.length > 0) {
			// 体素尺寸：0=自动从标注包围盒对角线推导（÷20 × 倍率）；>0=手动覆盖
			let voxelSize = this.annotationClusteringVoxelSize;
			if (!(voxelSize > 0)) {
				this.scene.annotations.updateBounds();   // 已有 _boundsDirty 缓存
				let box = this.scene.annotations.boundingBox;
				let diag = (box && !box.isEmpty()) ? box.min.distanceTo(box.max) : 0;
				voxelSize = (diag > 0 ? diag / 20 : 10) * this.annotationClusteringVoxelFactor;
			}
			this._clusterVoxelSizeUsed = voxelSize;   // 供调试/HUD 读取本帧实际体素尺寸

			// Stage 0 距离分层（按类型阈值）：<= 该类型 near 显示原图标，> near 参与聚合
			let farList = [];
			let nearList = [];
			for (let anno of visibleNow) {
				if (anno._clusterDist > this._getTypeNear(anno._clusterType)) {
					farList.push(anno);
				} else {
					nearList.push(anno);
				}
			}

			// 近处标注始终显示原始图标
			displaySet = new Set(nearList);

			if (farList.length > 0) {
				// 缓存防抖：相机快速移动时复用上一帧分组（只更新位置），避免 DOM 频繁变动卡顿
				let camMoved = this._lastClusterCamPos
					? camPos.distanceTo(this._lastClusterCamPos)
					: Infinity;
				this._lastClusterCamPos = camPos.clone();
				let fastMoving = camMoved > cullingRange * 0.02;

				if (fastMoving && this._lastClusterResult && this._lastClusterResult.length > 0) {
					// 快速移动中：复用上一帧分组，用本帧坐标更新位置
					clusterList = this._rebuildClusterPositions(this._lastClusterResult, farList);
				} else {
					// Stage 1 空间筛选：3D 世界体素分箱（按类型分组，世界坐标稳定，减少旋转闪烁）
					clusterList = this._computeVoxelClusters(farList, voxelSize);
					this._lastClusterResult = clusterList;
				}

				// Stage 2 屏幕像素二次过滤：仅远景聚合点（平均距离 >= 该类型 far）叠加屏幕合并，
				// 且只合并同类型聚合点；中景聚合点原样保留。
				clusterList = this._mergeOverlappingClusters(clusterList, cellSize);

				// 远处标注全部由聚合点表示（含孤立的数值 1），不显示原始图标
			} else {
				this._lastClusterResult = null;
			}
		} else {
			// 聚合关闭：全部独立显示
			displaySet = new Set(visibleNow);
			this._lastClusterResult = null;
		}

		// ===== 提交 display：对本帧触达的标注做「绝对赋值」，不依赖帧间差集 =====
		// 为什么不能只对差集赋值：新变可见 / 新建的远距离标注既不在 displaySet（该由聚合圆代表），
		// 也不在上一帧的 visibleAnnotations 里，首帧完全拿不到赋值，会带着构造期的
		// _display 残值显示出来，与聚合圆重叠。
		// 另外 set expand（经上面 annotation.expand = expand 触发）会对折叠父节点无条件写
		// display = true，且发生在本次遍历途中，只有在这里无条件压回才能纠正。
		for (let annotation of touchedNow) {
			annotation.display = displaySet.has(annotation);
		}

		// 上一帧触达过、本帧没触达的（移出视距/视锥、被父节点折叠剪掉、或已从树上移除）：隐藏
		for (let annotation of this.visibleAnnotations) {
			if (!touchedNow.has(annotation)) {
				annotation.display = false;
			}
		}

		// 统一存 Set（旧代码这里存的是数组 visibleNow，与 :1804 的初始化类型不一致）
		this.visibleAnnotations = touchedNow;

		// ===== 更新聚合标记 DOM =====
		this._updateClusterMarkers(clusterList);
	}

	// Stage 2 屏幕像素二次过滤：仅对远景聚合点（平均距离 >= 该类型 far）做屏幕合并，
	// 相邻同类型远景聚合点（屏幕距离 < mergeDist）合并成一个，避免远距离堆叠看不清数字。
	// 中景聚合点（平均距离 < 该类型 far）原样保留，不参与屏幕合并；不同类型永不合并。
	_mergeOverlappingClusters(clusterList, mergeDist) {
		if (clusterList.length <= 1) return clusterList;

		let merged = [];
		let used = new Array(clusterList.length).fill(false);

		for (let i = 0; i < clusterList.length; i++) {
			if (used[i]) continue;

			// 中景聚合点：不参与屏幕合并，原样通过（按该类型 far 判断）
			if (!(clusterList[i].dist >= this._getTypeFar(clusterList[i].type))) {
				used[i] = true;
				merged.push(clusterList[i]);
				continue;
			}

			let group = [clusterList[i]];
			used[i] = true;
			// 用当前聚合点作为基准，贪心吸收附近所有同类型远景聚合点
			for (let j = i + 1; j < clusterList.length; j++) {
				if (used[j]) continue;
				if (clusterList[j].type !== clusterList[i].type) continue;  // 仅合并同类型
				if (!(clusterList[j].dist >= this._getTypeFar(clusterList[j].type))) continue;  // 仅合并远景点
				let dx = clusterList[j].x - clusterList[i].x;
				let dy = clusterList[j].y - clusterList[i].y;
				if (dx * dx + dy * dy < mergeDist * mergeDist) {
					group.push(clusterList[j]);
					used[j] = true;
				}
			}
			if (group.length === 1) {
				merged.push(group[0]);
			} else {
				// 合并多个聚合点的成员，重新算质心
				let allMembers = [];
				for (let g of group) allMembers = allMembers.concat(g.members);
				merged.push(this._groupToCluster(allMembers));
			}
		}
		return merged;
	}

	// Stage 1 空间筛选：3D 世界体素分箱（每帧重新计算）。按类型 + 世界坐标 voxel 分组，
	// 不同类型天然落入不同组（key 带类型前缀），世界坐标稳定，相机旋转/平移时同一物理组
	// 保持在一起，减少闪烁。孤立体素（组内仅 1 个）也生成数值 1 的聚合点，保持风格统一。
	_computeVoxelClusters(list, voxelSize) {
		let v = (voxelSize > 0) ? voxelSize : 1;
		let grid = new Map();  // "type|vx,vy,vz" -> [anno, ...]
		for (let anno of list) {
			let vx = Math.floor(anno._clusterWX / v);
			let vy = Math.floor(anno._clusterWY / v);
			let vz = Math.floor(anno._clusterWZ / v);
			let key = anno._clusterType + "|" + vx + "," + vy + "," + vz;
			let group = grid.get(key);
			if (!group) { group = []; grid.set(key, group); }
			group.push(anno);
		}

		// 所有体素都生成聚合点（包括孤立体素，数值 1）
		let clusterList = [];
		for (let members of grid.values()) {
			clusterList.push(this._groupToCluster(members));
		}
		return clusterList;
	}

	// 把一组标注转成聚合点（屏幕质心 + 数量 + 世界坐标质心 + 平均相机距离）
	_groupToCluster(members) {
		let n = members.length;
		let sx = 0, sy = 0, swx = 0, swy = 0, swz = 0, sd = 0;
		for (let m of members) {
			sx += m._clusterX; sy += m._clusterY;
			swx += m._clusterWX; swy += m._clusterWY; swz += m._clusterWZ;
			sd += m._clusterDist;
		}
		return {
			x: sx / n, y: sy / n, count: n,
			wx: swx / n, wy: swy / n, wz: swz / n,
			dist: sd / n,
			type: (n > 0 ? members[0]._clusterType : 'default'),
			members: members
		};
	}

	// 缓存防抖帧：用上一帧分组结果，但用本帧屏幕坐标重算聚合点位置（平滑跟随）
	// 保留所有聚合点（含 count=1 的孤立组），与计算帧逻辑一致，避免闪烁
	_rebuildClusterPositions(lastResult, visibleNow) {
		// 建立 anno -> 本帧坐标/距离的快速查找
		let posMap = new Map();
		for (let anno of visibleNow) {
			posMap.set(anno, { x: anno._clusterX, y: anno._clusterY, wx: anno._clusterWX, wy: anno._clusterWY, wz: anno._clusterWZ, d: anno._clusterDist });
		}
		let clusterList = [];
		for (let c of lastResult) {
			let alive = [];
			let sx = 0, sy = 0, swx = 0, swy = 0, swz = 0, sd = 0;
			for (let m of c.members) {
				let p = posMap.get(m);
				if (p) {
					alive.push(m);
					sx += p.x; sy += p.y;
					swx += p.wx; swy += p.wy; swz += p.wz;
					sd += p.d;
				}
			}
			if (alive.length > 0) {
				let n = alive.length;
				clusterList.push({
					x: sx / n, y: sy / n, count: n,
					wx: swx / n, wy: swy / n, wz: swz / n,
					dist: sd / n,
					type: c.type,
					members: alive
				});
			}
		}
		return clusterList;
	}

	// 聚合标记 DOM 池管理：复用已创建的标记，按本帧 clusterList 数量增减可见性
	_updateClusterMarkers(clusterList) {
		if (!this._clusterMarkers) {
			this._clusterMarkers = [];
		}

		// 聚合关闭或无聚合点：隐藏所有标记
		if (!this.annotationClusteringEnabled || clusterList.length === 0) {
			for (let el of this._clusterMarkers) {
				el.style.display = 'none';
			}
			return;
		}

		// 按需创建新标记（池复用，避免每帧创建/销毁 DOM）
		while (this._clusterMarkers.length < clusterList.length) {
			let el = document.createElement('div');
			el.className = 'annotation-cluster';
			// 点击飞向聚合中心：相机移动到聚合点附近，走近后聚合自动散开
			el.addEventListener('click', () => {
				let wp = el._clusterWorldPos;
				if (!wp) return;
				let target = new THREE.Vector3(wp.x, wp.y, wp.z);
				// 相机停在目标方向上、距离缩短到当前的一半，让聚合散开
				let camPos = this.scene.cameraP.position;
				let dir = new THREE.Vector3().subVectors(camPos, target);
				let curDist = dir.length();
				if (curDist > 0) {
					dir.multiplyScalar(1 / curDist);
				} else {
					dir.set(0, 0, 1);
				}
				let endPos = new THREE.Vector3().copy(target).add(dir.multiplyScalar(Math.max(curDist * 0.5, 5)));
				Utils.moveTo(this.scene, endPos, target);
			});
			this.renderArea.appendChild(el);
			this._clusterMarkers.push(el);
		}

		// 更新可见标记
		for (let i = 0; i < this._clusterMarkers.length; i++) {
			let el = this._clusterMarkers[i];
			if (i < clusterList.length) {
				let c = clusterList[i];
				el.textContent = c.count;
				el.style.setProperty('--anno-x', c.x + 'px');
				el.style.setProperty('--anno-y', c.y + 'px');
				el.style.display = 'flex';
				el._clusterWorldPos = { x: c.wx, y: c.wy, z: c.wz };
				this._applyClusterMarkerStyle(el, c.type);
			} else {
				el.style.display = 'none';
			}
		}
	}

	// 按类型应用聚合标记样式：追加类型修饰类 + 内联覆盖（background/color/尺寸/圆角/字号/背景图）。
	// 池复用时先清掉上一次的类型类与内联覆盖，避免样式串味；未注册的类型回退默认青色样式。
	_applyClusterMarkerStyle(el, type) {
		type = type || 'default';
		let prev = el._clusterAppliedType;
		let ver = this._clusterStyleVersion || 0;
		// 类型未变且样式版本未变 → 无需重设（版本变化表示某类型样式被改过，需强制重刷）
		if (prev === type && el._clusterStyleVersion === ver) return;

		// 清除上一次的类型修饰类与内联覆盖
		if (prev) {
			el.classList.remove('annotation-cluster--' + prev);
		}
		el.style.background = '';
		el.style.backgroundImage = '';
		el.style.color = '';
		el.style.width = '';
		el.style.height = '';
		el.style.borderRadius = '';
		el.style.fontSize = '';

		el.classList.add('annotation-cluster--' + type);

		let style = this.annotationClusteringTypeStyles[type];
		let marker = style && style.marker;
		if (marker) {
			if (marker.background != null) el.style.background = marker.background;
			if (marker.backgroundImage != null) el.style.backgroundImage = marker.backgroundImage;
			if (marker.color != null) el.style.color = marker.color;
			if (marker.size != null) {
				el.style.width = marker.size + 'px';
				el.style.height = marker.size + 'px';
			}
			if (marker.borderRadius != null) el.style.borderRadius = marker.borderRadius;
			if (marker.fontSize != null) el.style.fontSize = marker.fontSize;
		}

		el._clusterAppliedType = type;
		el._clusterStyleVersion = ver;
	}

	updateMaterialDefaults(pointcloud) {
		// PROBLEM STATEMENT:
		// * [min, max] of intensity, source id, etc. are computed as point clouds are loaded
		// * the point cloud material won't know the range it should use until some data is loaded
		// * users can modify the range at runtime, but sensible default ranges should be 
		//   applied even if no GUI is present
		// * display ranges shouldn't suddenly change even if the actual range changes over time.
		//   e.g. the root node has intensity range [1, 478]. One of the descendants increases range to 
		//   [0, 2047]. We should not automatically change to the new range because that would result
		//   in sudden and drastic changes of brightness. We should adjust the min/max of the sidebar slider.

		const material = pointcloud.material;

		const attIntensity = pointcloud.getAttribute("intensity");

		if (attIntensity != null && material.intensityRange[0] === Infinity) {
			material.intensityRange = [...attIntensity.range];
		}

		// const attIntensity = pointcloud.getAttribute("intensity");
		// if(attIntensity && material.intensityRange[0] === Infinity){
		// 	material.intensityRange = [...attIntensity.range];
		// }

		// let attributes = pointcloud.getAttributes();

		// for(let attribute of attributes.attributes){
		// 	if(attribute.range){
		// 		let range = [...attribute.range];
		// 		material.computedRange.set(attribute.name, range);
		// 		//material.setRange(attribute.name, range);
		// 	}
		// }


	}

	update(delta, timestamp) {

		if (Potree.measureTimings) performance.mark("update-start");

		this.dispatchEvent({
			type: 'update_start',
			delta: delta,
			timestamp: timestamp
		});


		const scene = this.scene;
		const camera = scene.getActiveCamera();
		const visiblePointClouds = this.scene.pointclouds.filter(pc => pc.visible)

		Potree.pointLoadLimit = Potree.pointBudget * 2;

		const lTarget = camera.position.clone().add(camera.getWorldDirection(new THREE.Vector3()).multiplyScalar(1000));
		this.scene.directionalLight.position.copy(camera.position);
		this.scene.directionalLight.lookAt(lTarget);


		for (let pointcloud of visiblePointClouds) {

			pointcloud.showBoundingBox = this.showBoundingBox;
			pointcloud.generateDEM = this.generateDEM;
			pointcloud.minimumNodePixelSize = this.minNodeSize;

			let material = pointcloud.material;

			material.uniforms.uFilterReturnNumberRange.value = this.filterReturnNumberRange;
			material.uniforms.uFilterNumberOfReturnsRange.value = this.filterNumberOfReturnsRange;
			material.uniforms.uFilterGPSTimeClipRange.value = this.filterGPSTimeRange;
			material.uniforms.uFilterPointSourceIDClipRange.value = this.filterPointSourceIDRange;

			material.classification = this.classifications;
			material.recomputeClassification();

			this.updateMaterialDefaults(pointcloud);
		}

		{
			if (this.showBoundingBox) {
				let bbRoot = this.scene.scene.getObjectByName("potree_bounding_box_root");
				if (!bbRoot) {
					let node = new THREE.Object3D();
					node.name = "potree_bounding_box_root";
					this.scene.scene.add(node);
					bbRoot = node;
				}

				let visibleBoxes = [];
				for (let pointcloud of this.scene.pointclouds) {
					for (let node of pointcloud.visibleNodes.filter(vn => vn.boundingBoxNode !== undefined)) {
						let box = node.boundingBoxNode;
						visibleBoxes.push(box);
					}
				}

				bbRoot.children = visibleBoxes;
			}
		}

		if (!this.freeze) {
			let result = Potree.updatePointClouds(scene.pointclouds, camera, this.renderer);


			// DEBUG - ONLY DISPLAY NODES THAT INTERSECT MOUSE
			//if(false){ 

			//	let renderer = viewer.renderer;
			//	let mouse = viewer.inputHandler.mouse;

			//	let nmouse = {
			//		x: (mouse.x / renderer.domElement.clientWidth) * 2 - 1,
			//		y: -(mouse.y / renderer.domElement.clientHeight) * 2 + 1
			//	};

			//	let pickParams = {};

			//	//if(params.pickClipped){
			//	//	pickParams.pickClipped = params.pickClipped;
			//	//}

			//	pickParams.x = mouse.x;
			//	pickParams.y = renderer.domElement.clientHeight - mouse.y;

			//	let raycaster = new THREE.Raycaster();
			//	raycaster.setFromCamera(nmouse, camera);
			//	let ray = raycaster.ray;

			//	for(let pointcloud of scene.pointclouds){
			//		let nodes = pointcloud.nodesOnRay(pointcloud.visibleNodes, ray);
			//		pointcloud.visibleNodes = nodes;

			//	}
			//}

			// const tStart = performance.now();
			// const worldPos = new THREE.Vector3();
			// const camPos = viewer.scene.getActiveCamera().getWorldPosition(new THREE.Vector3());
			// let lowestDistance = Infinity;
			// let numNodes = 0;

			// viewer.scene.scene.traverse(node => {
			// 	node.getWorldPosition(worldPos);

			// 	const distance = worldPos.distanceTo(camPos);

			// 	lowestDistance = Math.min(lowestDistance, distance);

			// 	numNodes++;

			// 	if(Number.isNaN(distance)){
			// 		console.error(":(");
			// 	}
			// });
			// const duration = (performance.now() - tStart).toFixed(2);

			// Potree.debug.computeNearDuration = duration;
			// Potree.debug.numNodes = numNodes;

			//console.log(lowestDistance.toString(2), duration);

			const tStart = performance.now();
			const campos = camera.position;
			let closestImage = Infinity;
			for (const images of this.scene.orientedImages) {
				for (const image of images.images) {
					const distance = image.mesh.position.distanceTo(campos);

					closestImage = Math.min(closestImage, distance);
				}
			}
			const tEnd = performance.now();

			if (result.lowestSpacing !== Infinity) {
				let near = result.lowestSpacing * 10.0;
				let far = -this.getBoundingBox().applyMatrix4(camera.matrixWorldInverse).min.z;

				far = Math.max(far * 1.5, 10000);
				near = Math.min(100.0, Math.max(0.01, near));
				near = Math.min(near, closestImage);
				far = Math.max(far, near + 10000);

				if (near === Infinity) {
					near = 0.1;
				}

				camera.near = near;
				camera.far = far;
			} else {
				// don't change near and far in this case
			}

			if (this.scene.cameraMode == CameraMode.ORTHOGRAPHIC) {
				camera.near = -camera.far;
			}
		}
		this.scene.cameraP.fov = this.fov;
		let controls = this.getControls();
		if (controls === this.deviceControls) {
			this.controls.setScene(scene);
			this.controls.update(delta);

			this.scene.cameraP.position.copy(scene.view.position);
			this.scene.cameraO.position.copy(scene.view.position);
		} else if (controls !== null) {
			controls.setScene(scene);
			controls.update(delta);

			if (typeof debugDisabled === "undefined") {
				this.scene.cameraP.position.copy(scene.view.position);
				this.scene.cameraP.rotation.order = "ZXY";
				this.scene.cameraP.rotation.x = Math.PI / 2 + this.scene.view.pitch;
				this.scene.cameraP.rotation.z = this.scene.view.yaw;
			}

			this.scene.cameraO.position.copy(scene.view.position);
			this.scene.cameraO.rotation.order = "ZXY";
			this.scene.cameraO.rotation.x = Math.PI / 2 + this.scene.view.pitch;
			this.scene.cameraO.rotation.z = this.scene.view.yaw;
		}

		camera.updateMatrix();
		camera.updateMatrixWorld();
		camera.matrixWorldInverse.copy(camera.matrixWorld).invert();

		{
			if (this._previousCamera === undefined) {
				this._previousCamera = this.scene.getActiveCamera().clone();
				this._previousCamera.rotation.copy(this.scene.getActiveCamera().rotation);
			}

			if (!this._previousCamera.matrixWorld.equals(camera.matrixWorld)) {
				this.dispatchEvent({
					type: "camera_changed",
					previous: this._previousCamera,
					camera: camera
				});
			} else if (!this._previousCamera.projectionMatrix.equals(camera.projectionMatrix)) {
				this.dispatchEvent({
					type: "camera_changed",
					previous: this._previousCamera,
					camera: camera
				});
			}

			this._previousCamera = this.scene.getActiveCamera().clone();
			this._previousCamera.rotation.copy(this.scene.getActiveCamera().rotation);

		}

		{
			let mouse = this.inputHandler.mouse;
			let domElement = this.renderer.domElement
			let ray = Utils.mouseToRay(mouse, camera, domElement.clientWidth, domElement.clientHeight);
			let raycaster = new THREE.Raycaster(ray.origin, ray.direction);

			// PPT 胶囊控制条：仅当鼠标悬停到对应包围盒(box)时显示，移开即隐藏
			this.scene.volumes
				.filter(v => v instanceof YDBoxVolume && v._visible && v.capsuleBar && v.box)
				.forEach(v => {
					let hit = [];
					v.box.raycast(raycaster, hit);
					v.capsuleBar.visible = hit.length > 0;
				});

			// YDBoxVolume 中视频/音频/PDF/PPT 的点击按钮需要 hover 高亮（PPT 为胶囊控制条）
			// 过滤隐藏按钮：射线检测不理会 visible，需显式排除未显示的控制条，避免误命中
			let clickBtns = [];
			clickBtns.push(...this.scene.volumes
				.filter(v => (v instanceof YDBoxVolume && v._visible && v.clickBtns && v.clickBtns.length))
				.flatMap(v => v.clickBtns)
				.filter(b => b.visible !== false));
			let intersects = raycaster.intersectObjects(clickBtns, true);
			if (intersects.length > 0) {
				let hit = intersects[0].object
				clickBtns.forEach(btn => btn.setHighlight(btn === hit))
			} else {
				clickBtns.forEach(btn => {
					btn.setHighlight(false)
				})
			}
		}

		{ // update clip boxes
			let boxes = [];

			// volumes with clipping enabled
			// 只看 clip，刻意不看 visible：两者正交 —— clip 决定是否裁点云，
			// visible 只决定盒子本身画不画（库的属性面板也是两个独立复选框，
			// SaveProject 分别序列化）。所以 visible=false 且 clip=true 的盒子
			// 仍会继续裁点云，这是"隐藏辅助盒但保留裁剪"的合法用法；调用方若想
			// 连裁剪一起关，需要把两个字段都设掉。
			//boxes.push(...this.scene.volumes.filter(v => (v.clip)));
			boxes.push(...this.scene.volumes.filter(v => (v.clip && (v instanceof YDBoxVolume || v instanceof BoxVolume))));

			// profile segments
			for (let profile of this.scene.profiles) {
				boxes.push(...profile.boxes);
			}

			// Needed for .getInverse(), pre-empt a determinant of 0, see #815 / #816
			let degenerate = (box) => box.matrixWorld.determinant() !== 0;

			let clipBoxes = boxes.filter(degenerate).map(box => {
				box.updateMatrixWorld();

				let boxInverse = box.matrixWorld.clone().invert();
				let boxPosition = box.getWorldPosition(new THREE.Vector3());

				return { box: box, inverse: boxInverse, position: boxPosition };
			});

			let clipPolygons = this.scene.polygonClipVolumes.filter(vol => vol.initialized);

			// 多边形棱柱（YDPolygonVolume）：收集语义与上面 clipBoxes 完全一致——
			// 只看 clip 不看 visible；退化矩阵与未成型(<3 点)的跳过。
			// 上传「逆矩阵 + 局部顶点 + 局部 Z 范围」，shader 里把世界点变回局部再判定。
			let clipPrisms = [];
			{
				let prismVolumes = this.scene.volumes.filter(v =>
					v.clip && v instanceof YDPolygonVolume && v.points && v.points.length >= 3);

				for (let v of prismVolumes) {
					v.updateMatrixWorld();
					if (v.matrixWorld.determinant() === 0) {
						continue;
					}
					clipPrisms.push({
						volume: v,
						inverse: v.matrixWorld.clone().invert(),
						vertices: v.points,
						zMin: v.zMin,
						zMax: v.zMax
					});
				}
			}

			// set clip volumes in material
			for (let pointcloud of visiblePointClouds) {
				pointcloud.material.setClipBoxes(clipBoxes);
				pointcloud.material.setClipPolygons(clipPolygons, this.clippingTool.maxPolygonVertices);
				pointcloud.material.setClipPrisms(clipPrisms);
				pointcloud.material.clipTask = this.clipTask;
				pointcloud.material.clipMethod = this.clipMethod;
			}

			// Mirror clip state to Gaussian Splats (bridge installed lazily on splat load).
			// No-op when spark isn't loaded — pure duck-typing hook, viewer stays spark-agnostic.
			if (typeof this._updateSplatClip === "function") {
				this._updateSplatClip();
			}

			// 设备区域着色(点云 + 高斯)。默认无高亮条目时内部推空数组，零开销。
			if (this.deviceRegionManager) {
				this.deviceRegionManager.update(visiblePointClouds, delta);
			}
		}

		{
			for (let pointcloud of visiblePointClouds) {
				pointcloud.material.elevationGradientRepeat = this.elevationGradientRepeat;
			}
		}

		{ // update navigation cube
			this.navigationCube.update(camera.rotation);
		}

		this.updateAnnotations();

		// 视距剔除：按相机距离隐藏/恢复 volume/measurement/profile（annotation 已在上面处理）
		this.updateViewDistanceCulling(camera);

		if (this.mapView) {
			this.mapView.update(delta);
			if (this.mapView.sceneProjection) {
				$("#potree_map_toggle").css("display", "block");

			}
		}

		TWEEN.update(timestamp);

		this.dispatchEvent({
			type: 'update',
			delta: delta,
			timestamp: timestamp
		});

		if (Potree.measureTimings) {
			performance.mark("update-end");
			performance.measure("update", "update-start", "update-end");
		}
	}

	getPRenderer() {
		if (this.useHQ) {
			if (!this.hqRenderer) {
				this.hqRenderer = new HQSplatRenderer(this);
			}
			this.hqRenderer.useEDL = this.useEDL;

			return this.hqRenderer;
		} else {
			if (this.useEDL && Features.SHADER_EDL.isSupported()) {
				if (!this.edlRenderer) {
					this.edlRenderer = new EDLRenderer(this);
				}

				return this.edlRenderer;
			} else {
				if (!this.potreeRenderer) {
					this.potreeRenderer = new PotreeRenderer(this);
				}

				return this.potreeRenderer;
			}
		}
	}

	renderVR() {

		let renderer = this.renderer;

		renderer.setClearColor(0x550000, 0);
		renderer.clear();

		let xr = renderer.xr;
		let dbg = new THREE.PerspectiveCamera();
		let xrCameras = xr.getCamera(dbg);

		if (xrCameras.cameras.length !== 2) {
			return;
		}

		let makeCam = this.vrControls.getCamera.bind(this.vrControls);

		{ // clear framebuffer
			if (this.background && this.background.indexOf("skybox") !== -1) {
				renderer.setClearColor(0xff0000, 1);
			} else if (this.background === "gradient") {
				renderer.setClearColor(0x112233, 1);
			} else if (this.background === "black") {
				renderer.setClearColor(0x000000, 1);
			} else if (this.background === "white") {
				renderer.setClearColor(0xFFFFFF, 1);
			} else {
				renderer.setClearColor(0x000000, 0);
			}

			renderer.clear();
		}

		// render background
		if (this.background && this.background.indexOf("skybox") !== -1) {
			let { skybox } = this;

			let cam = makeCam();
			skybox.camera.rotation.copy(cam.rotation);
			skybox.camera.fov = cam.fov;
			skybox.camera.aspect = cam.aspect;

			// let dbg = new THREE.Object3D();
			let dbg = skybox.parent;
			// dbg.up.set(0, 0, 1);
			dbg.rotation.x = Math.PI / 2;

			// skybox.camera.parent = dbg;
			// dbg.children.push(skybox.camera);

			dbg.updateMatrix();
			dbg.updateMatrixWorld();

			skybox.camera.updateMatrix();
			skybox.camera.updateMatrixWorld();
			skybox.camera.updateProjectionMatrix();

			renderer.render(skybox.scene, skybox.camera);
			// renderer.render(skybox.scene, cam);
		} else if (this.background === "gradient") {
			// renderer.render(this.scene.sceneBG, this.scene.cameraBG);
		}

		this.renderer.xr.getSession().updateRenderState({
			depthNear: 0.1,
			depthFar: 10000
		});

		let cam = null;
		let view = null;

		{ // render world scene
			cam = makeCam();
			cam.position.z -= 0.8 * cam.scale.x;
			cam.parent = null;
			// cam.near = 0.05;
			cam.near = viewer.scene.getActiveCamera().near;
			cam.far = viewer.scene.getActiveCamera().far;
			cam.updateMatrix();
			cam.updateMatrixWorld();

			this.scene.scene.updateMatrix();
			this.scene.scene.updateMatrixWorld();
			this.scene.scene.matrixAutoUpdate = false;

			let camWorld = cam.matrixWorld.clone();
			view = camWorld.clone().invert();
			this.scene.scene.matrix.copy(view);
			this.scene.scene.matrixWorld.copy(view);

			cam.matrix.identity();
			cam.matrixWorld.identity();
			cam.matrixWorldInverse.identity();

			renderer.render(this.scene.scene, cam);

			this.scene.scene.matrixWorld.identity();

		}

		for (let pointcloud of this.scene.pointclouds) {

			let viewport = xrCameras.cameras[0].viewport;

			pointcloud.material.useEDL = false;
			pointcloud.screenHeight = viewport.height;
			pointcloud.screenWidth = viewport.width;

			// automatically switch to paraboloids because they cause far less flickering in VR, 
			// when point sizes are larger than around 2 pixels
			// if(Features.SHADER_INTERPOLATION.isSupported()){
			// 	pointcloud.material.shape = Potree.PointShape.PARABOLOID;
			// }
		}

		// render point clouds
		for (let xrCamera of xrCameras.cameras) {

			let v = xrCamera.viewport;
			renderer.setViewport(v.x, v.y, v.width, v.height);

			// xrCamera.fov = 90;

			{ // estimate VR fov
				let proj = xrCamera.projectionMatrix;
				let inv = proj.clone().invert();

				let p1 = new THREE.Vector4(0, 1, -1, 1).applyMatrix4(inv);
				let rad = p1.y
				let fov = 180 * (rad / Math.PI);

				xrCamera.fov = fov;
			}

			for (let pointcloud of this.scene.pointclouds) {
				const { material } = pointcloud;
				material.useEDL = false;
			}

			let vrWorld = view.clone().invert();
			vrWorld.multiply(xrCamera.matrixWorld);
			let vrView = vrWorld.clone().invert();

			this.pRenderer.render(this.scene.scenePointCloud, xrCamera, null, {
				viewOverride: vrView,
			});

		}

		{ // render VR scene
			let cam = makeCam();
			cam.parent = null;

			renderer.render(this.sceneVR, cam);
		}

		renderer.resetState();

	}

	renderDefault() {
		let pRenderer = this.getPRenderer();

		{ // resize
			const width = this.scaleFactor * this.renderArea.clientWidth;
			const height = this.scaleFactor * this.renderArea.clientHeight;

			this.renderer.setSize(width, height);
			const pixelRatio = this.renderer.getPixelRatio();
			const aspect = width / height;

			const scene = this.scene;

			scene.cameraP.aspect = aspect;
			scene.cameraP.updateProjectionMatrix();

			let frustumScale = this.scene.view.radius;
			scene.cameraO.left = -frustumScale;
			scene.cameraO.right = frustumScale;
			scene.cameraO.top = frustumScale * 1 / aspect;
			scene.cameraO.bottom = -frustumScale * 1 / aspect;
			scene.cameraO.updateProjectionMatrix();

			scene.cameraScreenSpace.top = 1 / aspect;
			scene.cameraScreenSpace.bottom = -1 / aspect;
			scene.cameraScreenSpace.updateProjectionMatrix();

			// CSS3D 叠加层（网页资源盒 id=9）跟随 canvas 尺寸
			if (this._css3dLayer) this._css3dLayer.resize();
		}

		pRenderer.clear();

		pRenderer.render(this.renderer);
		this.renderer.render(this.overlay, this.overlayCamera);
	}

	render() {
		if (Potree.measureTimings) performance.mark("render-start");

		try {

			const vrActive = this.renderer.xr.isPresenting;

			if (vrActive) {
				this.renderVR();
			} else {
				this.renderDefault();
			}

		} catch (e) {
			this.onCrash(e);
		}

		if (Potree.measureTimings) {
			performance.mark("render-end");
			performance.measure("render", "render-start", "render-end");
		}
	}

	resolveTimings(timestamp) {
		if (Potree.measureTimings) {
			if (!this.toggle) {
				this.toggle = timestamp;
			}
			let duration = timestamp - this.toggle;
			if (duration > 1000.0) {

				let measures = performance.getEntriesByType("measure");

				let names = new Set();
				for (let measure of measures) {
					names.add(measure.name);
				}

				let groups = new Map();
				for (let name of names) {
					groups.set(name, {
						measures: [],
						sum: 0,
						n: 0,
						min: Infinity,
						max: -Infinity
					});
				}

				for (let measure of measures) {
					let group = groups.get(measure.name);
					group.measures.push(measure);
					group.sum += measure.duration;
					group.n++;
					group.min = Math.min(group.min, measure.duration);
					group.max = Math.max(group.max, measure.duration);
				}

				let glQueries = Potree.resolveQueries(this.renderer.getContext());
				for (let [key, value] of glQueries) {

					let group = {
						measures: value.map(v => { return { duration: v } }),
						sum: value.reduce((a, i) => a + i, 0),
						n: value.length,
						min: Math.min(...value),
						max: Math.max(...value)
					};

					let groupname = `[tq] ${key}`;
					groups.set(groupname, group);
					names.add(groupname);
				}

				for (let [name, group] of groups) {
					group.mean = group.sum / group.n;
					group.measures.sort((a, b) => a.duration - b.duration);

					if (group.n === 1) {
						group.median = group.measures[0].duration;
					} else if (group.n > 1) {
						group.median = group.measures[parseInt(group.n / 2)].duration;
					}

				}

				let cn = Array.from(names).reduce((a, i) => Math.max(a, i.length), 0) + 5;
				let cmin = 10;
				let cmed = 10;
				let cmax = 10;
				let csam = 6;

				let message = ` ${"NAME".padEnd(cn)} |`
					+ ` ${"MIN".padStart(cmin)} |`
					+ ` ${"MEDIAN".padStart(cmed)} |`
					+ ` ${"MAX".padStart(cmax)} |`
					+ ` ${"SAMPLES".padStart(csam)} \n`;
				message += ` ${"-".repeat(message.length)}\n`;

				names = Array.from(names).sort();
				for (let name of names) {
					let group = groups.get(name);
					let min = group.min.toFixed(3);
					let median = group.median.toFixed(3);
					let max = group.max.toFixed(3);
					let n = group.n;

					message += ` ${name.padEnd(cn)} |`
						+ ` ${min.padStart(cmin)} |`
						+ ` ${median.padStart(cmed)} |`
						+ ` ${max.padStart(cmax)} |`
						+ ` ${n.toString().padStart(csam)}\n`;
				}
				message += `\n`;
				console.log(message);

				performance.clearMarks();
				performance.clearMeasures();
				this.toggle = timestamp;
			}
		}
	}
	shot() {
		var cameraPBK = this.scene.cameraP.fov;
		// this.scene.cameraP.fov = 30;

		const width = window.innerWidth;
		const height = window.innerHeight;
		const pixelBuffer = new Uint8Array(width * height * 4);
		var target = this.renderer.getRenderTarget();
		var renderTarget = new THREE.WebGLRenderTarget(width, height);
		this.renderer.setRenderTarget(renderTarget);

		this.render();

		this.renderer.readRenderTargetPixels(renderTarget, 0, 0, width, height, pixelBuffer);
		this.renderer.setRenderTarget(target);
		var imageData = new ImageData(new Uint8ClampedArray(pixelBuffer), window.innerWidth, window.innerHeight);

		const canvas = document.createElement('canvas');
		const ctx = canvas.getContext('2d');
		canvas.width = width;
		canvas.height = height;
		ctx.putImageData(imageData, 0, 0);
		const img = canvas.toDataURL('image/png');
		// document.body.appendChild(canvas);
		//start for debug
		// const link = document.createElement( 'a' );
		// link.style.display = 'none';
		// document.body.appendChild(link)
		// link.download = 'pathtraced-render.png';
		// link.href = this.renderer.domElement.toDataURL().replace( 'image/png', 'image/octet-stream' );
		// link.click();
		//end for debug
		// this.scene.cameraP.fov = fovBK;
		// let image = new THREE.Image();
		// // renderer.render(scene, camera);

		// let imgData = this.domElement.toDataURL("image/jpeg");//这里可以选择png格式jpeg格式
		// image.src = imgData;
		// image.id = 'image';
		// this.document.body.appendChild(image);
		// debugBase64(imgData);
		// downloadImage(imgData);
		// this.isShot = false;
		// this.fov = this.fovBK;
		// this.scene.cameraP = this.cameraPBK;
		// this.scene.view.position = this.viewPositionBK;
		// let startTarget = this.scene.view.getPivot();
		// this.scene.view.lookAt(startTarget);
		this.update(this.clock.getDelta(), 500);
		this.render();
		return imageData;
		// this.scene.cameraP = cameraPBK;
	}
	beginCaptureAndRadius(camera, target, fov, r) {
		const distance = target.distanceTo(camera.position);

		// 如果没有传入视场角，就简单求出来一个用
		let fovRad = Math.atan2(r, distance);
		let fovDeg = fov || THREE.MathUtils.radToDeg(fovRad);

		this.cameraPBK = new THREE.PerspectiveCamera(this.scene.cameraP);
		this.fovBK = this.scene.cameraP.fov;

		this.scene.cameraP = new THREE.PerspectiveCamera(camera);
		this.scene.cameraP.fov = fovDeg;

		this.viewPositionBK = this.scene.view.position;
		this.scene.view.position.copy(camera.position);
		this.fov = fovDeg;
		this.scene.fov = fovDeg;

		this.scene.view.lookAt(target);
		this.update(this.clock.getDelta(), 500);

		this.isShot = true;
		let imageData = this.shot();

		return imageData;
	}
	beginCapture(camera, target) {
		// const distance = target.distanceTo(camera.position);

		// let fovRad = Math.atan2(r, distance);
		let fovDeg = THREE.MathUtils.radToDeg(camera.fov);
		this.cameraPBK = new THREE.PerspectiveCamera(this.scene.cameraP);
		this.fovBK = this.scene.cameraP.fov;
		// this.cameraPBK = this.scene.cameraP.clone();
		this.scene.cameraP = new THREE.PerspectiveCamera(camera);
		this.scene.cameraP.fov = fovDeg;
		// this.scene.cameraP.position.copy(camera.position);
		// this.scene.cameraP.rotation.copy(camera.rotation);
		// this.scene.cameraP.fov=camera.fov;
		this.viewPositionBK = this.scene.view.position;
		this.targetBK = this.scene.view.getPivot();
		this.scene.view.position.copy(camera.position);
		this.fov = fovDeg;
		this.scene.fov = fovDeg;
		// this.scene.view.rotation.copy(camera.rotation);
		this.scene.view.lookAt(target);
		this.update(this.clock.getDelta(), 500);

		this.isShot = true;
		let imageData = this.shot();

		return imageData;
	}
	endCapture() {
		this.isShot = false;
		this.fov = this.fovBK;
		this.scene.cameraP = this.cameraPBK;
		this.scene.view.position = this.viewPositionBK;
		let startTarget = this.scene.view.getPivot();
		this.scene.view.lookAt(startTarget);
	}
	captureScreen(viewer, camera, camTarget) {

		return new Promise(function (resolve, reject) {
			viewer.cameraPBK = new THREE.PerspectiveCamera(viewer.scene.cameraP);
			viewer.scene.cameraP = new THREE.PerspectiveCamera(camera);
			//viewer.viewPositionBK = viewer.scene.view.position;
			viewer.viewPositionBK = new THREE.Vector3(viewer.scene.view.position);
			viewer.viewRotationBK = new THREE.Euler(viewer.scene.view.rotation);
			viewer.scene.view.position.copy(camera.position);
			// viewer.scene.view.lookAt(camTarget);
			// viewer.update(viewer.clock.getDelta(), 500);
			const width = window.innerWidth;
			const height = window.innerHeight;
			var renderTarget = new THREE.WebGLRenderTarget(width, height);
			// 渲染到渲染目标
			viewer.renderer.setRenderTarget(renderTarget);
			// this.renderer.render(scene, camera);
			viewer.render();
			var target = viewer.renderer.getRenderTarget();
			// viewer.renderer.setRenderTarget(target); // 恢复默认渲染目标（屏幕）
			viewer.renderer.setRenderTarget(null); // 恢复默认渲染目标（屏幕）
			// 读取渲染目标的像素数据
			var pixelBuffer = new Uint8Array(window.innerWidth * window.innerHeight * 4); // RGBA 格式
			viewer.renderer.readRenderTargetPixels(renderTarget, 0, 0, window.innerWidth, window.innerHeight, pixelBuffer);

			// 将像素数据转换为 ImageData 对象
			var imageData = new ImageData(new Uint8ClampedArray(pixelBuffer), window.innerWidth, window.innerHeight);
			//
			viewer.scene.cameraP = viewer.cameraPBK;
			viewer.scene.view.position = viewer.viewPositionBK;
			// viewer.scene.view.rotation = viewer.viewRotationBK;
			let startTarget = viewer.scene.view.getPivot();
			viewer.scene.view.lookAt(startTarget);
			// viewer.update(viewer.clock.getDelta(), 500);
			//
			// 解析完成，将结果传递给 resolve 函数
			resolve(imageData);
		});
	}
	loop(timestamp) {

		if (this.stats) {
			this.stats.begin();
		}

		if (Potree.measureTimings) {
			performance.mark("loop-start");
		}

		this.update(this.clock.getDelta(), timestamp);
		this.render();
		// CSS3D 叠加层（网页资源盒 id=9）：在 WebGL 渲染之后同步 DOM 层位姿。
		// 层不存在（无网页资源）时零开销。
		if (this._css3dLayer) {
			this._css3dLayer.update(this.scene.getActiveCamera());
		}
		// if(this.isShot === true)
		// {
		// 	this.shot();
		// }
		// let vrActive = viewer.renderer.xr.isPresenting;
		// if(vrActive){
		// 	this.update(this.clock.getDelta(), timestamp);
		// 	this.render();
		// }else{

		// 	this.update(this.clock.getDelta(), timestamp);
		// 	this.render();
		// }


		if (Potree.measureTimings) {
			performance.mark("loop-end");
			performance.measure("loop", "loop-start", "loop-end");
		}

		this.resolveTimings(timestamp);

		Potree.framenumber++;

		if (this.stats) {
			this.stats.end();
		}
	}

	postError(content, params = {}) {
		let message = this.postMessage(content, params);

		message.element.addClass("potree_message_error");

		return message;
	}

	postMessage(content, params = {}) {
		let message = new Message(content);

		let animationDuration = 100;

		message.element.css("display", "none");
		message.elClose.click(() => {
			message.element.slideToggle(animationDuration);

			let index = this.messages.indexOf(message);
			if (index >= 0) {
				this.messages.splice(index, 1);
			}
		});

		this.elMessages.prepend(message.element);

		message.element.slideToggle(animationDuration);

		this.messages.push(message);

		if (params.duration !== undefined) {
			let fadeDuration = 500;
			let slideOutDuration = 200;
			setTimeout(() => {
				message.element.animate({
					opacity: 0
				}, fadeDuration);
				message.element.slideToggle(slideOutDuration);
			}, params.duration)
		}

		return message;
	}
};
